// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Articles\Models\AthleteArticle.cs
export interface AthleteArticle extends LeanArticle {
  athleteId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Articles\Models\LeanArticle.cs
export interface LeanArticle {
  articleId: string;
  writerId: string;
  headline: string;
  subHeadline: string;
  publishedOn: string;
  endsOn?: string;
  writerFirstName: string;
  writerLastName: string;
  status: ArticleStatus;
  editorNote: string;
  submittedOn: string;
  modifiedOn: string;
  listHeadline: string;
  adMode: number;
  isBlog: boolean;
  campaignId?: string;
  thumbnailId?: string;
  thumbnailUrl: string;
  canonicalUrl: string;
  writerCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Articles\Models\TeamArticleCount.cs
export interface TeamArticleCount {
  sportSeasonId: string;
  year: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\AssociationContestRestrictionsList.cs
export interface AssociationContestRestrictionsList {
  associationId: string;
  contestRestrictions: ContestRestriction[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\AssociationsExcludedGenderSportList.cs
export interface ExtendedStateAssociationList {
  states: ExtendedStateAssociations[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\AssociationsExcludedGenderSportList.cs
export interface ExtendedStateAssociations {
  state: string;
  associations: ExtendedAssociationData[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\AssociationsExcludedGenderSportList.cs
export interface ExtendedAssociationData {
  abbreviation: string;
  excludedGenderSports: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\ContestRestriction.cs
export interface ContestRestriction {
  associationId: string;
  sportSeasonId: string;
  startDate?: string;
  endDate?: string;
  updatedOn: string;
  maxCount?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\StateAssociationQualifier.cs
export interface StateAssociationQualifier {
  stateAssociationQualifierId: string;
  sportSeasonId: string;
  associationId: string;
  teamId: string;
  athleteId: string;
  isAlternate: boolean;
  isAcceptedByStateAssociation: boolean;
  acceptedByStateAssociationOn?: string;
  createdOn: string;
  modifiedOn: string;
  position?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\StateAssociationQualifier.cs
export interface StateAssociationQualifier_Swimming
  extends StateAssociationQualifier {
  eventType: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\StateAssociationQualifier.cs
export interface StateAssociationQualifier_Track_And_Field
  extends StateAssociationQualifier {
  eventId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Associations\Models\StateAssociationQualifyingPeriod.cs
export interface StateAssociationQualifyingPeriod {
  associationId: string;
  sportSeasonId: string;
  qualificationPeriodId: string;
  startsOn: string;
  endsOn: string;
  publishOn?: string;
  createdOn: string;
  modifiedOn: string;
  timeZone: string;
  maxAthletesPerEvent?: number;
  isRestrictionEnabled: boolean;
  isRestrictedByDivision?: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Careers\Models\Career.cs
export interface Career {
  careerId: string;
  firstName: string;
  lastName: string;
  bio: string;
  primarySport: string;
  primaryPosition: string;
  jersey: string;
  heightFeet?: number;
  heightInches?: number;
  weight?: number;
  graduatingClass?: number;
  facebookProfile: string;
  twitterHandle: string;
  hasProfileImage: boolean;
  isManuallyManaged: boolean;
  createdOn: string;
  modifiedOn: string;
  migratedOn?: string;
  migratedToCareerId?: string;
  excludeFromSearchEngines: boolean;
  photoVersion?: number;
  photoUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Careers\Models\CareerClaimEligibility.cs
export interface CareerClaimEligibility {
  careerId: string;
  userId: string;
  isEligibleForAthleteClaim: boolean;
  isEligibleForParentClaim: boolean;
  athleteClaimIneligibilityType: AthleteClaimIneligibilityType;
  ineligibleForAthleteClaimReason: string;
  parentClaimIneligibilityType: ParentClaimIneligibilityType;
  ineligibleForParentClaimReason: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Careers\Models\CareerDataAvailability.cs
export interface CareerDataAvailability {
  careerId: string;
  hasArticles: boolean;
  hasPhotos: boolean;
  hasVideos: boolean;
  hasHudlVideos: boolean;
  hasAwards: boolean;
  hasStats: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contacts\Models\Contact.cs
export interface Contact {
  contactId: string;
  userId: string;
  roleId: string;
  accessId1?: string;
  accessId2?: string;
  position: string;
  title: string;
  loginCode: string;
  source: string;
  accessNote: string;
  createdByUserId?: string;
  createdOn?: string;
  firstLoginOn?: string;
  lastLoginOn?: string;
  createdByPosition: string;
  firstAppUsageOn?: string;
  firstAppPlatform: string;
  lastAppUsageOn?: string;
  lastAppPlatform: string;
  isActive?: boolean;
  roleName: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userIsMember: boolean;
  canStartChat: boolean;
  photoUrl: string;
  permissions: Permission[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contacts\Models\ParentCount.cs
export interface ParentCount {
  teamId: string;
  allSeasonId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contacts\Models\Permission.cs
export interface Permission {
  permissionId: string;
  permissionFeatureId: string;
  contactId: string;
  name: string;
  identifier: string;
  type: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contacts\Models\StaffCount.cs
export interface StaffCount {
  teamId: string;
  allSeasonId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\BracketMoverData.cs
export interface BracketMoverData {
  autoAdvance: string[];
  modifiedScores: string[];
  unboundMatchups: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestBasic.cs
export interface ContestBasic {
  teams: ContestTeamBasic[];
  contestId: string;
  importedOn?: string;
  modifiedOn?: string;
  createdOn?: string;
  isScheduleImport: boolean;
  hasStory: boolean;
  shouldBuildNewStory: boolean;
  shouldOverrideConf: boolean;
  isScoreImport: boolean;
  isFlagged: boolean;
  isGow: boolean;
  isMultiTeam: boolean;
  isDeleted: boolean;
  hasResult: boolean;
  location: string;
  details: string;
  state: string;
  city: string;
  name: string;
  gameSource?: string;
  scoreSource?: string;
  dateCode: DateCodes;
  date?: string;
  tournamentBracketId?: string;
  tournamentId?: string;
  scoresAddedByUserId?: string;
  sportSeasonId: string;
  scoreAddedOn?: string;
  storyPickedupOn?: string;
  scoreStamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestCalculatedFields.cs
export interface ContestCalculatedFields {
  contestId: string;
  teamsCalculated: ContestTeamCalculatedFields[];
  contestState: ContestState;
  allowReportFinalScore: boolean;
  allowEditContestResults: boolean;
  hasContestPage: boolean;
  calculatedContestResult: ContestResult;
  canonicalUrl: string;
  isDateTba: boolean;
  isTimeTba: boolean;
  contestAlias: string;
  isLiveGameInProgress: boolean;
  overtimePeriodsPlayed: number;
  overtimeAlias: string;
  overtimeShortAlias: string;
  currentLivePeriod: string;
  currentLiveTime: string;
  currentScorerFirstName: string;
  currentScorerLastName: string;
  currentScorerUserId?: string;
  rolesWhoCanEnterScores: string[];
  reasonWhyCannotEnterScores: string;
  isLiveScoringEnabled: boolean;
  isGameChangerConnected: boolean;
  hasGameChangerImportedStats: boolean;
  bracketMatchupId?: string;
  bracketIsPublished?: boolean;
  bracketGameIndex?: number;
  bracketGamesInMatchup?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestScoresUpdate.cs
export interface ContestScoresUpdate {
  contestId: string;
  overrideResultWithWinnerBox: boolean;
  teamScores: ContestTeamScoresUpdate[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestTeamBasic.cs
export interface ContestTeamBasic {
  id: string;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
  teamId?: string;
  contestId: string;
  sportSeasonId: string;
  statSupplierId?: string;
  resultString: string;
  index?: number;
  scorePrediction?: number;
  result?: string;
  score?: number;
  place?: number;
  dnp: boolean;
  isTeamTba: boolean;
  isForfeit: boolean;
  isDeleted: boolean;
  hasStats: boolean;
  totalsNeedUpdate: boolean;
  statEnteredOn?: string;
  bFieldsUpdatedOn?: string;
  scoresUpdatedOn?: string;
  teamModifiedOn?: string;
  homeAwayType: HomeAwayTypes;
  contestType: ContestTypes;
  teamCanonicalUrl: string;
  name: string;
  city: string;
  state: string;
  formattedName: string;
  formattedNameWithoutState: string;
  mascotUrl: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  schoolNameAcronym: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestTeamCalculatedFields.cs
export interface ContestTeamCalculatedFields {
  contestId: string;
  teamId?: string;
  hasHudlStatsImported: boolean;
  calculatedTeamContestResult: ContestResult;
  currentLiveScore?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestTeamScoresUpdate.cs
export interface ContestTeamScoresUpdate {
  teamId?: string;
  isWinner: boolean;
  isForfeit: boolean;
  result?: string;
  score?: number;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestTournament.cs
export interface ContestTournament {
  tournamentId: string;
  name: string;
  city: string;
  state: string;
  startedOn?: string;
  endedOn?: string;
  splitBrackets: boolean;
  allowReportedScores: boolean;
  tournamentOrganizationId: string;
  isPlayOff: boolean;
  tournamentHasLogo: boolean;
  tournamentClickUrl: string;
  tournamentLogoHeight?: number;
  tournamentLogoWidth?: number;
  tournamentUpdatedOn?: string;
  sportSeasonId: string;
  tournamentBracketId: string;
  teamCount?: number;
  isBracketPublished?: boolean;
  bracketName: string;
  bracketCity: string;
  bracketHasLogo: boolean;
  bracketClickUrl: string;
  bracketLogoWidth?: number;
  bracketLogoHeight?: number;
  bracketPublishedOn?: string;
  lockGameDetails: boolean;
  bracketUpdatedOn?: string;
  tournamentBracketRoundId: string;
  isRoundEndDateTba: boolean;
  roundDateTba: boolean;
  roundStartedOn: string;
  roundEndedOn?: string;
  roundTimeTba: boolean;
  tournamentBracketGamesInMatchup: number;
  tournamentBracketMatchupId: string;
  tournamentBracketMatchupGamesInMatchup: number;
  tournamentBracketGameId: string;
  tournamentBracketGameIndex: number;
  contestId: string;
  tournamentOrganizationName: string;
  tournamentLogoImageUrl: string;
  bracketLogoImageUrl: string;
  tournamentCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ContestUpdate.cs
export interface ContestUpdate {
  contestId: string;
  deleted: boolean;
  feedUrl: string;
  esUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\CopyScheduleInfo.cs
export interface CopyScheduleInfo {
  fromSportSeasonId: string;
  defaultTime: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\GameChangerContestFile.cs
export interface GameChangerContestFile {
  gameChangerContestFileId: string;
  sportSeasonId: string;
  contestId: string;
  gameChangerRefId: string;
  contestDate?: string;
  contestTime?: string;
  contestFileName: string;
  createdOn: string;
  importedOn?: string;
  importContestId?: string;
  importSource: string;
  opponentId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\GameStory.cs
export interface GameStory {
  gameStoryId: string;
  type: string;
  contestId?: string;
  publishedOn?: string;
  story: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\InGameScoreData.cs
export interface InGameScoreData {
  inGameScoreDataId: number;
  contestId: string;
  userId: string;
  userFirstName: string;
  userLastName: string;
  isUserOfficialScoreReporter: boolean;
  teamScore?: number;
  teamPeriodData?: number;
  opponentScore?: number;
  opponentPeriodData?: number;
  gamePeriod: string;
  gameTime?: number;
  submittedOn: string;
  localStamp: string;
  commentary: string;
  hasPhoto: boolean;
  photoHeight?: number;
  photoWidth?: number;
  videoId?: string;
  jobId?: number;
  videoFileName: string;
  videoFileNameSrc: string;
  hasVideo: boolean;
  videoErrorMessage: string;
  isVideoTranscoded: boolean;
  platform: string;
  videoTranscodedOn?: string;
  videoSubmittedOn?: string;
  isDeleted: boolean;
  updatedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\InGameSummary.cs
export interface InGameSummary {
  contestId: string;
  lastUpdatedOn?: string;
  totalCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\PlayerOfTheBase.cs
export interface PlayerOfTheBase {
  teamId: string;
  sportSeasonId: string;
  athleteId: string;
  careerProfileId: string;
  comments: string;
  type: string;
  createdOn: string;
  athleteFirstName: string;
  athleteLastName: string;
  athletePhotoUrl: string;
  badgeUrl: string;
  ssid: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\PlayerOfTheGame.cs
export interface PlayerOfTheGame extends PlayerOfTheBase {
  playerOfTheGameId: string;
  contestId: string;
  modifiedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\PlayerOfTheImage.cs
export interface PlayerOfTheImage {
  id: string;
  name: string;
  nameSubtitle: string;
  photoUrl: string;
  playerHeading: string;
  playerType: string;
  gameType: string;
  color: string;
  sport: string;
  subtitle: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\PlayerOfTheYear.cs
export interface PlayerOfTheYear extends PlayerOfTheBase {
  playerOfTheYearId: string;
  sponsorId: string;
  isSponsorOptedIn: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGame.cs
export interface QwixcoreGame {
  qwixcoreGameId: string;
  contestId: string;
  sportSeasonId: string;
  userId?: string;
  scorerRequestId?: number;
  isGameStarted: boolean;
  gameStartedOn?: string;
  isGameCompleted: boolean;
  isGameCompletedBySystem: boolean;
  gameCompletedOn?: string;
  isGameScorerCheckedIn: boolean;
  gameScorerCheckedInOn?: string;
  isGameDelayed: boolean;
  gameDelayedOn?: string;
  isGamePostponed: boolean;
  gamePostponedOn?: string;
  isCommentaryBlocked: boolean;
  commentaryBlockedOn?: string;
  createdOn: string;
  modifiedOn: string;
  shortScoringUrl: string;
  shortViewingUrl: string;
  shortCancellationUrl: string;
  shortReportIssueUrl: string;
  viewCount: number;
  allowGameResetByScorer: boolean;
  ignoreBfields: boolean;
  shortEmailScoringUrl: string;
  shortSmsscoringUrl: string;
  shortGlobalPopupScoringUrl: string;
  lastGameUpdateOn?: string;
  lastScorerChangeOn?: string;
  schoolId: string;
  isQualityGame: boolean;
  isPrimaryScorer: boolean;
  additionalOvertime: number;
  scorerCurrentStatus: ScorerRequestStatus;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameAlertAbuseReport.cs
export interface QwixcoreGameAlertAbuseReport {
  qwixcoreGameAlertAbuseReportId: number;
  qwixcoreGameAlertId: number;
  qwixcoreGameId: string;
  userId: string;
  reportedStamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameData.cs
export interface QwixcoreGameData {
  qwixcoreGameDataId: number;
  qwixcoreGameId: string;
  alertTypeId: number;
  gamePeriod: string;
  gameTime: string;
  schoolId?: string;
  player1?: number;
  player2?: number;
  player3?: number;
  player1Id?: string;
  player2Id?: string;
  player3Id?: string;
  yardInfo?: number;
  fieldSide?: string;
  currentScore: string;
  scorerCommentary: string;
  localTime: string;
  stamp: string;
  notificationAssetId: string;
  hasPhoto: boolean;
  photoHeight?: number;
  photoWidth?: number;
  scorerRequestId?: number;
  sponsorNote: string;
  sponsorImageUrl: string;
  sponsorClickUrl1: string;
  sponsorTextUrl1: string;
  sponsorClickUrl2: string;
  sponsorTextUrl2: string;
  videoId?: string;
  isDeleted: boolean;
  updateOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameInactivity.cs
export interface QwixcoreGameInactivity {
  qwixcoreGameInactivityId: number;
  qwixcoreGameId: string;
  userId: string;
  reportedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameNotificationHistory.cs
export interface QwixcoreGameNotificationHistory {
  qwixcoreGameNotificationHistoryId: number;
  qwixcoreGameId: string;
  scorerRequestId: number;
  requestStatus: number;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGamePeriod.cs
export interface QwixcoreGamePeriod {
  qwixcoreGamePeriodId: number;
  qwixcoreGameId: string;
  identifier: string;
  sort: number;
  isInProgress: boolean;
  isCompleted: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameSchool.cs
export interface QwixcoreGameSchool {
  qwixcoreGameSchoolId: number;
  qwixcoreGameId: string;
  schoolId: string;
  sportSeasonId: string;
  homeAwayType: number;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
  final?: number;
  modifiedOn: string;
  timeOuts?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameStateLog.cs
export interface QwixcoreGameStateLog {
  qwixcoreGameStateLogId: number;
  qwixcoreGameId: string;
  isGameStarted: boolean;
  gameStartedOn?: string;
  isGameCompleted: boolean;
  isGameCompletedBySystem: boolean;
  gameCompletedOn?: string;
  isGameScorerCheckedIn: boolean;
  gameScorerCheckedInOn?: string;
  isGameDelayed: boolean;
  gameDelayedOn?: string;
  isGamePostponed: boolean;
  gamePostponedOn?: string;
  isCommentaryBlocked: boolean;
  commentaryBlockedOn?: string;
  isIgnoreBFields: boolean;
  userId?: string;
  qwixcoreScorerRequestId?: number;
  currentPeriod: string;
  logCreatedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreGameViewCount.cs
export interface QwixcoreGameViewCount {
  qwixcoreGameId: string;
  viewCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreScorerRequest.cs
export interface QwixcoreScorerRequest {
  qwixcoreScorerRequestId: number;
  contestId: string;
  sportSeasonId: string;
  currentStatus: ScorerRequestStatus;
  userId: string;
  submittedOn: string;
  modifiedOn: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\QwixcoreScorerRequestLog.cs
export interface QwixcoreScorerRequestLog {
  qwixcoreScorerRequestLogId: number;
  qwixcoreScorerRequestId: number;
  requestStatus: ScorerRequestStatus;
  logCreatedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\ScoreReportedStateRestriction.cs
export interface ScoreReportedStateRestriction {
  sportSeasonId: string;
  stateId: string;
  scoreReportedStateRestrictionId: number;
  createdOn: string;
  userId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\SportSeasonsContestCounts.cs
export interface SportSeasonsContestCounts {
  allSeasonId: string;
  teamId: string;
  counts: ContestCount[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\SportSeasonsContestCounts.cs
export interface ContestCount {
  sportSeasonId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\SportSeasonBracketCount.cs
export interface SportSeasonBracketCount {
  sportSeasonId: string;
  year: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\Tournament.cs
export interface Tournament {
  tournamentId: string;
  sportSeasonId: string;
  name: string;
  notes: string;
  startsOn?: string;
  endsOn?: string;
  city: string;
  state: string;
  isDeleted: boolean;
  tournamentOrganizationId: string;
  splitBrackets: boolean;
  isPlayOff: boolean;
  hasLogo: boolean;
  hideLogo: boolean;
  allowReportedScores: boolean;
  logoClickUrl: string;
  logoWidth?: number;
  logoHeight?: number;
  lastModifiedOn?: string;
  defaultGameTime?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracket.cs
export interface TournamentBracket {
  tournamentBracketId: string;
  sportSeasonId: string;
  type: string;
  tournamentId: string;
  name: string;
  notes: string;
  index: number;
  publishedOn?: string;
  timeZone: string;
  city: string;
  hasLogo: boolean;
  hideLogo: boolean;
  teamCount?: number;
  victoryPlacement?: number;
  losersPlayBackIn: boolean;
  losersBracketMustWinTwice: boolean;
  logoClickUrl: string;
  logoWidth?: number;
  logoHeight?: number;
  bracketLevel: string;
  lastModifiedOn?: string;
  pdfFileName: string;
  sortOrder?: number;
  victoryPlacementCount?: number;
  pdfDate?: string;
  quadName1: string;
  quadName2: string;
  quadName3: string;
  quadName4: string;
  guaranteedGameCount?: number;
  gamesInMatchup?: number;
  finalFourText: string;
  championshipText: string;
  isPublished: boolean;
  lockGameDetails: boolean;
  autoAdvanceMatchupSeeding: boolean;
  tournamentOrganizationId: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketRound.cs
export interface TournamentBracketRound {
  tournamentBracketRoundId: string;
  sportSeasonId: string;
  tournamentId: string;
  tournamentBracketId: string;
  index: number;
  name: string;
  type: TournamentRoundType;
  roundDateTime: string;
  roundDateTba: boolean;
  roundTimeTba: boolean;
  roundEndsOn?: string;
  isRoundEndDateTba: boolean;
  lastModifiedOn?: string;
  subIndex: string;
  tournamentOrganizationId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketRoundMatchup.cs
export interface TournamentBracketRoundMatchup {
  tournamentBracketRoundMatchupId: string;
  sportSeasonId: string;
  tournamentId: string;
  tournamentBracketId: string;
  tournamentBracketRoundId: string;
  team1Id: string;
  team1SourceMatchupId: string;
  isTeam1SourceLoser: boolean;
  team2Id: string;
  team2SourceMatchupId: string;
  isTeam2SourceLoser: boolean;
  index: number;
  matchUpNumber?: number;
  isTeam1Tba: boolean;
  isTeam2Tba: boolean;
  isTeam1Bye: boolean;
  isTeam2Bye: boolean;
  team1Seed: string;
  team2Seed: string;
  gamesInMatchup: number;
  description: string;
  createdOn: string;
  modifiedOn: string;
  loserTargetMatchupId?: string;
  winnerTargetMatchupId?: string;
  winnerSchoolId?: string;
  loserSchoolId?: string;
  isChampionshipMatchup: boolean;
  championshipPlaceNumber?: number;
  onlyPlayIfNeeded: boolean;
  matchupName: string;
  notificationText: string;
  statusVerifiedOn?: string;
  tournamentOrganizationId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketRoundMatchupGame.cs
export interface TournamentBracketRoundMatchupGame {
  tournamentBracketRoundMatchupGameId: string;
  tournamentId: string;
  tournamentBracketId: string;
  tournamentBracketRoundId: string;
  tournamentBracketRoundMatchupId: string;
  contestId: string;
  sportSeasonId: string;
  index: number;
  gameDateTime: string;
  isGameDateTba: boolean;
  isGameTimeTba: boolean;
  createdOn: string;
  location: string;
  contestType: string;
  team1HomeAwayType?: number;
  team2HomeAwayType?: number;
  lastModifiedOn?: string;
  isOvertime: boolean;
  tournamentOrganizationId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketSportList.cs
export interface TournamentBracketSportList {
  sports: TournamentSport[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketSportList.cs
export interface TournamentSport {
  name: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketStateList.cs
export interface TournamentBracketStateList {
  allSeasonId: string;
  states: TournamentState[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Models\Tournaments\TournamentBracketStateList.cs
export interface TournamentState {
  stateCode: string;
  name: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Divisions\Models\SectionDivision.cs
export interface SectionDivision {
  sectionDivisionId: string;
  name: string;
  sectionId: string;
  sectionName: string;
  sportSeasonId: string;
  sportSeasonName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Divisions\Models\StateDivision.cs
export interface StateDivision {
  stateDivisionId: string;
  name: string;
  stateId: string;
  stateCode: string;
  stateName: string;
  sportSeasonId: string;
  sportSeasonName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteContestsForDisplay.cs
export interface AthleteContestsForDisplay {
  careerId: string;
  nextContest: AthleteContestForDisplay;
  mostRecentContest: AthleteContestForDisplay;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteContestsForDisplay.cs
export interface AthleteContestForDisplay {
  contest: ContestBasic;
  calculatedFields: ContestCalculatedFields;
  contestDescription: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboard {
  sportSeasonId: string;
  contextId: string;
  group: string;
  subGroup: string;
  statHeader: string;
  positionCategory: string;
  classYear: number;
  teamSize: number;
  columns: AthleteStatLeaderboardColumn[];
  rows: AthleteStatLeaderboardRow[];
  categories: AthleteStatLeaderboardCategory[];
  years: AthleteStatLeaderboardYear[];
  minimums: string[];
  positions: AthleteStatLeaderboadPosition[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboardColumn {
  name: string;
  displayName: string;
  header: string;
  isSortable: boolean;
  isHighlighted: boolean;
  sortDirection: PlayerSeasonStatsColumnSortDirection;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboardRow {
  careerId: string;
  athleteId: string;
  athleteFirstName: string;
  athleteLastName: string;
  athleteStatsUrl: string;
  athleteStatsUrlMobile: string;
  teamId: string;
  schoolName: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
  schoolCity: string;
  schoolState: string;
  teamCanonicalUrl: string;
  rank: number;
  position: string;
  teamSize: number;
  stats: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboardCategory {
  groupName: string;
  subGroupName: string;
  canonicalUrl: string;
  statHeader: string;
  sportSeasonId: string;
  contextId?: string;
  teamSize: number;
  positionCategory: string;
  classYear: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboardYear {
  sportSeasonId: string;
  yearDisplay: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AthleteStatLeaderboard.cs
export interface AthleteStatLeaderboadPosition {
  displayName: string;
  includedPositions: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AvailableSeasonList.cs
export interface AvailableSeasonList {
  teamId: string;
  sportSeasonId: string;
  seasons: AvailableSeason[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\AvailableSeasonList.cs
export interface AvailableSeason {
  year: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ContestCalculatedGateway.cs
export interface ContestCalculatedGateway {
  contest: ContestBasic;
  calculatedFields: ContestCalculatedFields;
  hudlInfo: ContestHudlInfo;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ContestHudlInfo.cs
export interface ContestHudlInfo {
  contestId: string;
  isHudlConnected: boolean;
  hasHudlStats: boolean;
  hasHudlStatsPending: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GatewaysStandings.cs
export interface GatewayStanding {
  teamCanonicalUrl: string;
  sportSeasonId: string;
  schoolMascotUrl: string;
  schoolColor4: string;
  schoolColor3: string;
  schoolColor2: string;
  schoolColor1: string;
  schoolNameAcronym: string;
  schoolName: string;
  schoolId: string;
  thirdPlace?: number;
  secondPlace?: number;
  firstPlace?: number;
  overallStandingPlacement?: number;
  conferenceWinLossTies: string;
  overallWinLossTies: string;
  standingsId: string;
  conferenceWinningPercentage: number;
  winningPercentage: number;
  conferenceStandingPlacement?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GatewaysStandings.cs
export interface TeamStandings {
  genderSport: string;
  footerInstructions: string;
  schoolId: string;
  sportSeasonId: string;
  isCoreSport: boolean;
  maxCount: number;
  standingSections: StandingSection[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GatewaysStandings.cs
export interface StandingSection {
  headerType: HeaderType;
  headerName: string;
  footerInstructions: string;
  fullStandingsLink: string;
  standings: GatewayStanding[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GatewaysStandings.cs
export enum HeaderType {
  League = 0,
  SectionDivision = 1,
  StateDivision = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GatewayStateRestriction.cs
export interface GatewayStateRestriction extends ScoreReportedStateRestriction {
  firstName: string;
  lastName: string;
  email: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\GenderSportsGrouped.cs
export interface GenderSportsGrouped {
  gender: string;
  sports: SportItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LandingPage.cs
export interface LandingPage {
  allSeasonId: string;
  contextId: string;
  canonicalUrl: string;
  seasons: LandingPageSeason[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LandingPage.cs
export interface LandingPageSeason {
  sportSeasonId: string;
  sportSeasonName: string;
  season: string;
  year: string;
  minGamesPlayed: number;
  categories: LandingPageStatCategory[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LandingPage.cs
export interface LandingPageStatCategory {
  statName: string;
  statHeader: string;
  nationalAverage: string;
  contextAverage: string;
  canonicalUrl: string;
  groupName: string;
  subGroupName: string;
  sportSeasonId: string;
  contextId?: string;
  teamSize: number;
  positionCategory: string;
  classYear: number;
  leaders: LandingPageLeader[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LandingPage.cs
export interface LandingPageLeader {
  careerId: string;
  athleteId: string;
  athleteFirstName: string;
  athleteLastName: string;
  athletePhotoUrl: string;
  athleteStatsUrl: string;
  athleteStatsUrlMobile: string;
  teamId: string;
  schoolName: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
  schoolCity: string;
  schoolState: string;
  teamCanonicalUrl: string;
  rank: number;
  statValue: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LeaderboardGroupings.cs
export interface LeaderboardGroupings {
  stateCode: string;
  sportSeasonId: string;
  aliases: GroupingAliases;
  sections: GroupingSection[];
  leagues: GroupingLeague[];
  divisions: GroupingDivision[];
  associations: GroupingAssociation[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LeaderboardLinks.cs
export interface LeaderboardLinks {
  allSeasonId: string;
  contextId: string;
  contextType: LeaderboardContextType;
  footerLinks: StatsLinks[];
  landingPage: StatsLinks;
  listPage: StatsLinks;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LeagueStanding.cs
export interface LeagueStanding {
  leagueName: string;
  canonicalUrl: string;
  conferenceWinningPercentage: number;
  conferenceWinLossTies: string;
  conferenceStandingPlacement: string;
  leagueAlias: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\NextContextBox.cs
export interface NextContestBox {
  teamId: string;
  sportSeasonId: string;
  contest: NextContest;
  calculatedFields: ContestCalculatedFields;
  videos: Video[];
  nfhsData: NextContestNfhs;
  tournament: NextContestTournament;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\NextContextBox.cs
export interface NextContest {
  city: string;
  name: string;
  gameSource?: string;
  scoreSource?: string;
  dateCode: DateCodes;
  date?: string;
  state: string;
  tournamentBracketId?: string;
  scoresAddedByUserId?: string;
  sportSeasonId: string;
  scoreAddedOn?: string;
  storyPickedupOn?: string;
  scoreStamp?: string;
  tournamentId?: string;
  details: string;
  hasResult: boolean;
  contestId: string;
  importedOn?: string;
  modifiedOn?: string;
  createdOn?: string;
  isScheduleImport: boolean;
  location: string;
  hasStory: boolean;
  shouldOverrideConf: boolean;
  isScoreImport: boolean;
  isFlagged: boolean;
  isGow: boolean;
  isMultiTeam: boolean;
  isDeleted: boolean;
  shouldBuildNewStory: boolean;
  teams: NextContestTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\NextContextBox.cs
export interface NextContestTeam {
  contestId: string;
  sportSeasonId: string;
  statSupplierId?: string;
  name: string;
  city: string;
  state: string;
  nameFormatted: string;
  resultString: string;
  index?: number;
  scorePrediction?: number;
  result?: string;
  score?: number;
  place?: number;
  dnp: boolean;
  isTeamTba: boolean;
  isForfeit: boolean;
  isDeleted: boolean;
  hasStats: boolean;
  totalsNeedUpdate: boolean;
  statEnteredOn?: string;
  bFieldsUpdatedOn?: string;
  scoresUpdatedOn?: string;
  teamModifiedOn?: string;
  homeAwayType: HomeAwayTypes;
  contestType: ContestTypes;
  mascotUrl: string;
  color1: string;
  teamId?: string;
  b30?: number;
  b29?: number;
  b28?: number;
  id: string;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  teamCanonicalUrl: string;
  b13?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b14?: number;
  standings: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\NextContextBox.cs
export interface NextContestNfhs {
  streamUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\NextContextBox.cs
export interface NextContestTournament {
  tournamentId: string;
  tournamentBracketId: string;
  name: string;
  tournamentLogoImageUrl: string;
  bracketLogoImageUrl: string;
  tournamentCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\OverallStanding.cs
export interface OverallStanding {
  winningPercentage: number;
  overallWinLossTies: string;
  homeWinLossTies: string;
  awayWinLossTies: string;
  neutralWinLossTies: string;
  points: number;
  pointsAgainst: number;
  streak: number;
  streakResult: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStats {
  teamId: string;
  sportSeasonId: string;
  groups: PlayerSeasonStatsGroup[];
  lastUpdated: StatsLastUpdated;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsGroup {
  name: string;
  subgroups: PlayerSeasonStatsSubgroup[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsSubgroup {
  name: string;
  stats: PlayerSeasonStatsSubgroupStats;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsSubgroupStats {
  columns: PlayerSeasonStatsColumn[];
  rows: PlayerSeasonStatsRow[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsColumn {
  name: string;
  header: string;
  displayName: string;
  isSortedColumn: boolean;
  overallValue: string;
  sortDirection: PlayerSeasonStatsColumnSortDirection;
  columnType: PlayerSeasonStatsColumnType;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsRowColumnData {
  value: string;
  href: string;
  caption: string;
  schoolNameAcronym: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsRow {
  columns: PlayerSeasonStatsRowColumnData[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsLeader {
  athleteId: string;
  athleteFirstName: string;
  athleteLastName: string;
  athletePhotoUrl: string;
  athleteCanonicalUrl: string;
  athleteCanonicalUrlMobile: string;
  athletePositions: string;
  athleteClassYear?: number;
  currentRank: number;
  stat: PlayerSeasonStatsLeaderStat;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatLeaderList {
  leaders: PlayerSeasonStatsLeader[];
  minimums: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export interface PlayerSeasonStatsLeaderStat {
  header: string;
  displayName: string;
  value: string;
  sortDirection: TeamSeasonStatsColumnSortDirection;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export enum PlayerSeasonStatsColumnType {
  Stat = 0,
  Jersey = 1,
  Name = 2,
  Date = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PlayerSeasonStats.cs
export enum PlayerSeasonStatsColumnSortDirection {
  None = 0,
  Asc = 1,
  Desc = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PreviousSeason.cs
export interface PreviousSeason {
  year: string;
  headCoach: string;
  leagueName: string;
  divisionName: string;
  overallRecord: string;
  leagueRecord: string;
  rankings: RankingTypeData[];
  links: WallItemLink[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\PreviousSeasonList.cs
export interface PreviousSeasonList {
  teamId: string;
  allSeasonId: string;
  seasons: PreviousSeason[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\RankingInput.cs
export interface RankingInput {
  schoolId: string;
  sportSeasonId: string;
  rank: number;
  rankingType: TeamRankingType;
  movement: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ReactBasicLink.cs
export interface ReactBasicLink {
  url: string;
  text: string;
  linkBehaviour: LinkBehaviour;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ReactSportPhotogallery.cs
export interface ReactSportPhotogallery extends SportPhotogallery {
  photographerBioUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ReactSportPhotogalleryList.cs
export interface ReactSportPhotogalleryList {
  allSeasonId?: string;
  stateCode: string;
  sectionId?: string;
  pageSize: number;
  page: number;
  viewAllUrl: string;
  galleries: ReactSportPhotogallery[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\RosterSummary.cs
export interface RosterSummary {
  hasTeamPhoto: boolean;
  athleteCount: number;
  photoAthleteCount: number;
  jerseyAthleteCount: number;
  hudlAthleteCount: number;
  staff: RosterStaffSummary[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\RosterSummary.cs
export interface RosterStaffSummary {
  name: string;
  position: string;
  lastLoginOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\ScheduleSummary.cs
export interface ScheduleSummary {
  contestCount: number;
  leagueContestCount: number;
  hudlContestCount: number;
  contestPlayedCount: number;
  contestFinalCount: number;
  contestStatsCount: number;
  potgCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\SeasonTournamentBracketList.cs
export interface SeasonTournamentBracketList {
  brackets: TournamentBracket[];
  tournaments: Tournament[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\SportList.cs
export interface SportList {
  stateCode: string;
  genderSportItems: GenderSportList[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\SportList.cs
export interface GenderSportList {
  gender: string;
  sports: SportItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\SportList.cs
export interface SportItem {
  allSeasonId: string;
  name: string;
  publicUrl: string;
  genderSport: string;
  formattedSportSeasonName: string;
  scheduleModel: string;
  statModel: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\StatsLastUpdated.cs
export interface StatsLastUpdated {
  timeStamp?: string;
  userName: string;
  userPosition: string;
  personId?: string;
  stdOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\StatsLinks.cs
export interface StatsLinks {
  displayText: string;
  canonicalUrl: string;
  linkBehaviour: LinkBehaviour;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\StatsLinks.cs
export enum LinkBehaviour {
  CurrentWindow = 0,
  NewTab = 1,
  NewWindow = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamContext.cs
export interface TeamContext {
  teamData: Team;
  schoolSportSeasonsData: SchoolSportSeason[];
  teamMenuData: MenuItem[];
  sportData: Sport;
  stateData: State;
  teamPhotoData: string;
  tda: TeamDataAvailability;
  teamSettings: TeamSettings;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamLeaderboardLeaderList.cs
export interface TeamLeaderboardLeaderList {
  teamId: string;
  sportSeasonId: string;
  athletes: TeamLeaderboardLeader[];
  cutoffs: TeamLeaderboardContextCutoffs[];
  minimums: TeamLeaderboardContextMinimums[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamLeaderboardLeaderList.cs
export interface TeamLeaderboardLeader {
  careerId: string;
  athleteId: string;
  athleteFirstName: string;
  athleteLastName: string;
  athleteStatsUrl: string;
  athleteStatsUrlMobile: string;
  athletePositions: string[];
  athleteClassYear?: number;
  athletePhotoUrl: string;
  currentRank: number;
  positionRanked: string;
  gradeRanked?: number;
  statName: string;
  statHeader: string;
  statValue: string;
  contextType: LeaderboardContextType;
  contextName: string;
  leaderboardCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamLeaderboardLeaderList.cs
export interface TeamLeaderboardContextCutoffs {
  contextType: LeaderboardContextType;
  cutoff: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamLeaderboardLeaderList.cs
export interface TeamLeaderboardContextMinimums {
  contextType: LeaderboardContextType;
  contextName: string;
  minimums: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamSeasonStats.cs
export interface TeamSeasonStats {
  teamId: string;
  sportSeasonId: string;
  groups: TeamSeasonGroup[];
  lastUpdated: StatsLastUpdated;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamSeasonStats.cs
export interface TeamSeasonGroup {
  name: string;
  subgroups: TeamSeasonSubgroup[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamSeasonStats.cs
export interface TeamSeasonSubgroup {
  name: string;
  stats: TeamSeasonStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamSeasonStats.cs
export interface TeamSeasonStat {
  name: string;
  header: string;
  displayName: string;
  teamOverallValue: string;
  teamLeagueValue: string;
  nationalValue: string;
  isSortedColumn: boolean;
  sortDirection: TeamSeasonStatsColumnSortDirection;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamSeasonStats.cs
export enum TeamSeasonStatsColumnSortDirection {
  None = 0,
  Asc = 1,
  Desc = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateAssociationQualificationsInfo.cs
export interface StateAssociationQualifierExtended
  extends StateAssociationQualifier {
  eventType: string;
  eventId: string;
  athleteFirstName: string;
  athleteLastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateAssociationQualificationsInfo.cs
export interface StateAssociationQualificationWindow {
  stateQualificationBodyImageUrl: string;
  stateQualificationBodyImageWidth: number;
  stateQualificationBodyImageHeight: number;
  stateQualificationBodyAbbreviation: string;
  stateQualificationBodyName: string;
  startsOn: string;
  endsOn: string;
  isActive: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateAssociationQualificationsInfo.cs
export interface TeamStateAssociationQualificationsInfo {
  key: string;
  teamId: string;
  sportSeasonId: string;
  qualificationUrl: string;
  stateAssociationQualifiers: StateAssociationQualifierExtended[];
  stateAssociationQualifiersCount: number;
  stateAssociationQualificationWindow: StateAssociationQualificationWindow;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateNominationsInfo.cs
export interface StateNominationExtended extends StateNomination {
  athleteFirstName: string;
  athleteLastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateNominationsInfo.cs
export interface StateNominationWindow {
  stateNominationBodyAbbreviation: string;
  stateNominationBodyName: string;
  startsOn: string;
  endsOn: string;
  isActive: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamStateNominationsInfo.cs
export interface TeamStateNominationsInfo {
  key: string;
  teamId: string;
  sportSeasonId: string;
  nominationUrl: string;
  stateNominations: StateNominationExtended[];
  stateNominationsCount: number;
  stateNominationWindow: StateNominationWindow;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\TeamVolunteerRequestForm.cs
export interface TeamVolunteerRequestForm {
  coachContactId?: string;
  coachFirstName: string;
  coachLastName: string;
  coachEmail: string;
  coachPhone: string;
  volunteerMembershipId?: string;
  volunteerFirstName: string;
  volunteerLastName: string;
  volunteerEmail: string;
  volunteerPhone: string;
  volunteerRole: string;
  volunteerComments: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserCareerRole.cs
export interface UserCareerRole {
  contactId: string;
  userId: string;
  careerId: string;
  userName: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userIsMember: boolean;
  athleteName: string;
  athleteFirstName: string;
  athleteLastName: string;
  athletePhotoUrl: string;
  permissionType: CareerRolePermissionType;
  relationship: CareerRolePermissionType;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFavoriteCareerSite.cs
export interface UserFavoriteCareerSite {
  careerProfileId: string;
  firstName: string;
  lastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFavoritesSite.cs
export interface UserFavoritesSite {
  userId: string;
  favoriteTeams: UserFavoriteTeamSite[];
  favoriteCareers: UserFavoriteCareerSite[];
  favoriteSettings: UserFavoriteTeamNotificationSettingSite[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFavoriteTeamNotificationSettingSite.cs
export interface UserFavoriteTeamNotificationSettingSite {
  favoriteTeamNotificationSettingsId: number;
  favoriteTeamId: number;
  enabled: boolean;
  name: string;
  shortName: string;
  sortOrder: number;
  emailEnabled: boolean;
  smsEnabled: boolean;
  webEnabled: boolean;
  userId: string;
  schoolId: string;
  allSeasonId: string;
  seasonName: string;
  favoriteTeamId1: number;
  stateCode: string;
  sectionId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFavoriteTeamSite.cs
export interface UserFavoriteTeamSite {
  favoriteTeamId: number;
  allSeasonId: string;
  seasonName: string;
  schoolId: string;
  schoolName: string;
  schoolCity: string;
  schoolState: string;
  schoolMascot: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFlyoutMenu.cs
export interface GatewayRole {
  header: string;
  subHeader: string;
  link: string;
  photoUrl: string;
  roleId: string;
  roleName: string;
  position: string;
  userId: string;
  personId: string;
  schoolId: string;
  accessId1?: string;
  accessId2?: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFlyoutMenu.cs
export interface GatewayFavoriteCareer {
  header: string;
  subHeader: string;
  link: string;
  photoUrl: string;
  careerProfileFirstName: string;
  careerProfileLastName: string;
  schoolName: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
  graduatingClass?: number;
  userId: string;
  careerProfileId: string;
  schoolId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFlyoutMenu.cs
export interface GatewayFavoriteTeam {
  header: string;
  subHeader: string;
  link: string;
  photoUrl: string;
  schoolId: string;
  schoolName: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
  allSeasonId: string;
  gender: string;
  sport: string;
  season: string;
  schoolMascot: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserFlyoutMenu.cs
export interface UserFlyoutMenu {
  notes: string;
  roles: GatewayRole[];
  favoriteCareers: GatewayFavoriteCareer[];
  favoriteTeams: GatewayFavoriteTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserPageData.cs
export interface UserPageData {
  favoriteTeams: UserPageDataTeamItem[];
  favoriteCareers: UserPageDataCareerItem[];
  roles: UserPageDataRoleItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserPageData.cs
export interface UserPageDataItem {
  photoUrl: string;
  header: string;
  link: string;
  subHeader: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserPageData.cs
export interface UserPageDataCareerItem extends UserPageDataItem {
  firstName: string;
  lastName: string;
  careerProfileId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserPageData.cs
export interface UserPageDataRoleItem extends UserPageDataItem {
  roleId: string;
  personId: string;
  accessId1: string;
  accessId2: string;
  permissions: RolePermission[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\UserPageData.cs
export interface UserPageDataTeamItem extends UserPageDataItem {
  allSeasonId: string;
  userFavoriteTeamRefId: number;
  seasonName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ContestIdsByDate.cs
export interface ContestIdsByDateList {
  scoreboardCanonicalUrlToday: string;
  scoreboardCanonicalUrlTomorrow: string;
  contestIdsByDate: ContestIdsByDate[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ContestIdsByDate.cs
export interface ContestIdsByDate {
  date: string;
  contestIds: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ScoreboardContest.cs
export interface ScoreboardContest {
  teams: ScoreboardContestTeam[];
  calculatedFields: ContestCalculatedFields;
  videos: Video[];
  contestId: string;
  sportSeasonId: string;
  sportSeasonName: string;
  gender: string;
  sport: string;
  level: string;
  nfhsStreamUrl: string;
  isMultiTeam: boolean;
  isDeleted: boolean;
  hasResult: boolean;
  location: string;
  dateCode: DateCodes;
  date?: string;
  tournamentId?: string;
  tournamentBracketId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ScoreboardContestBasic.cs
export interface ScoreboardContestBasic {
  teams: ScoreboardContestTeamBasic[];
  calculatedFields: ContestCalculatedFields;
  contestId: string;
  sportSeasonId: string;
  hasResult: boolean;
  dateCode: DateCodes;
  date?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ScoreboardContestTeam.cs
export interface ScoreboardContestTeam extends ScoreboardContestTeamBasic {
  allSeasonId: string;
  hasAssignedScorer: boolean;
  scorerRequestId: number;
  scorerStatus: ScorerRequestStatus;
  scorerUserId: string;
  scorerName: string;
  scorerPhotoUrl: string;
  isActiveScorer: boolean;
  isOfficialScoreReporter: boolean;
  submittedScoreCount: number;
  acceptedScoreCount: number;
  calculatedScoreRating: number;
  isQualityScorer: boolean;
  qualityGames: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Contests\ScoreboardContestTeamBasic.cs
export interface ScoreboardContestTeamBasic {
  teamId?: string;
  contestId: string;
  sportSeasonId: string;
  resultString: string;
  result?: string;
  score?: number;
  isTeamTba: boolean;
  isForfeit: boolean;
  isDeleted: boolean;
  hasStats: boolean;
  homeAwayType: HomeAwayTypes;
  contestType: ContestTypes;
  teamCanonicalUrl: string;
  name: string;
  city: string;
  state: string;
  formattedName: string;
  formattedNameWithoutState: string;
  mascotUrl: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  schoolNameAcronym: string;
  standings: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingAliases {
  leagueAlias: string;
  sectionAlias: string;
  divisionAlias: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingDma {
  dmaId: string;
  name: string;
  rankingsCanonicalUrl: string;
  scoreboardCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingState {
  stateId: string;
  stateCode: string;
  name: string;
  publicUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingSection {
  sectionId: string;
  name: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingLeague {
  leagueId: string;
  name: string;
  canonicalUrl: string;
  sectionId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingDivision {
  divisionId: string;
  name: string;
  type: string;
  canonicalUrl: string;
  sectionId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingAssociation {
  associationId: string;
  name: string;
  code: string;
  rankingsCanonicalUrl: string;
  scoreboardCanonicalUrl: string;
  sectionId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingItems.cs
export interface GroupingTeam {
  teamId: string;
  name: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\GroupingStateList.cs
export interface GroupingStateList {
  allSeasonId: string;
  states: GroupingState[];
  topFavoritedTeams: GroupingTeam[];
  formattedSportSeasonName: string;
  scheduleModel: string;
  statModel: string;
  gender: string;
  sport: string;
  canonicalUrl: string;
  defaultSportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\HomeGroupings.cs
export interface HomeGroupings {
  states: GroupingState[];
  topFavoritedTeams: GroupingTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\SectionGroupings.cs
export interface SectionGroupings {
  stateCode: string;
  allSeasonId: string;
  sectionId: string;
  canonicalUrl: string;
  formattedSportSeasonName: string;
  scheduleModel: string;
  statModel: string;
  gender: string;
  sport: string;
  stateName: string;
  defaultSportSeasonId: string;
  aliases: GroupingAliases;
  leagues: GroupingLeague[];
  divisions: GroupingDivision[];
  associations: GroupingAssociation[];
  topFavoritedTeams: GroupingTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\StateGroupings.cs
export interface StateGroupings {
  stateCode: string;
  topFavoritedTeams: GroupingTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Groupings\StateSportGroupings.cs
export interface StateSportGroupings {
  stateCode: string;
  allSeasonId: string;
  year: string;
  season: string;
  canonicalUrl: string;
  formattedSportSeasonName: string;
  scheduleModel: string;
  statModel: string;
  gender: string;
  sport: string;
  stateName: string;
  defaultSportSeasonId: string;
  aliases: GroupingAliases;
  dmas: GroupingDma[];
  sections: GroupingSection[];
  leagues: GroupingLeague[];
  divisions: GroupingDivision[];
  associations: GroupingAssociation[];
  topFavoritedTeams: GroupingTeam[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\LeadersLink\LeadersLink.cs
export interface LeadersLink {
  text: string;
  url: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\ConcordiaLeaderList.cs
export interface ConcordiaLeader {
  sportSeasonName: string;
  season: string;
  year: string;
  sportSeasonId: string;
  contextualStatLeadersUrl: string;
  contextualStatLeadersUrlMobile: string;
  stats: ConcordiaLeaderStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\ConcordiaLeaderList.cs
export interface ConcordiaLeaderStat {
  athleteId: string;
  firstName: string;
  lastName: string;
  photoUrl: string;
  schoolName: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
  schoolCity: string;
  schoolState: string;
  stat: StatDisplay;
  statLeaderboardUrl: string;
  athleteStatsUrl: string;
  athleteStatsUrlMobile: string;
  grade: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TeamRankingContext.cs
export interface TeamRankingContext {
  contextType: TeamRankingType;
  contextName: string;
  contextId: string;
  canonicalUrl: string;
  entries: TeamRankingEntry[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TeamRankingContextList.cs
export interface TeamRankingContextList {
  schoolId: string;
  sportSeasonId: string;
  contexts: TeamRankingContext[];
  notes: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TeamRankingEntry.cs
export interface TeamRankingEntry {
  rank: number;
  rating?: number;
  movement: string;
  strength?: number;
  leagueRecord: string;
  overallRecord: string;
  schoolId: string;
  teamCanonicalUrl: string;
  schoolName: string;
  schoolCity: string;
  schoolState: string;
  schoolMascotUrl: string;
  schoolMascot: string;
  schoolNameAcronym: string;
  schoolFormattedName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TopTeamRanking.cs
export interface TopTeamRanking {
  rank: number;
  schoolId: string;
  schoolName: string;
  schoolFormattedName: string;
  schoolNameAcronym: string;
  schoolMascotUrl: string;
  stateCode: string;
  overall: string;
  strength?: number;
  teamLink: string;
  teamSize?: number;
  lastUpdated?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TopTeamRankingList.cs
export interface TopTeamRankingList {
  allSeasonId: string;
  sectionId: string;
  stateCode: string;
  teamSize?: number;
  count?: number;
  lastUpdated?: string;
  seasonRankings: TopTeamSeasonRankingList[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rankings\TopTeamSeasonRankingList.cs
export interface TopTeamSeasonRankingList {
  sportSeasonName: string;
  season: string;
  year: string;
  sportSeasonId: string;
  fullRankingsLink: string;
  lastUpdated?: string;
  rankings: TopTeamRanking[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AllTimeRoster.cs
export interface AllTimeRoster {
  year: string;
  seasons: AllTimeRosterSeason[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AllTimeRosterAthlete.cs
export interface AllTimeRosterAthlete {
  firstName: string;
  lastName: string;
  canonicalUrl: string;
  gradeLevel: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AllTimeRosterList.cs
export interface AllTimeRosterList {
  allSeasonId: string;
  teamId: string;
  yearCount: number;
  rosters: AllTimeRoster[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AllTimeRosterSeason.cs
export interface AllTimeRosterSeason {
  year: string;
  season: string;
  seasonName: string;
  canonicalUrl: string;
  headCoach: string;
  athletes: AllTimeRosterAthlete[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AnalystAthlete.cs
export interface AnalystAthlete {
  athleteId: string;
  sportSeasonId: string;
  analystId: string;
  analystCategoryId: string;
  analystPlayerId: string;
  analystName: string;
  categoryName: string;
  team: string;
  sort: number;
  isActive: boolean;
  analystUrl: string;
  athleteNotes: string;
  categoryImageUrl: string;
  customColumnName1: string;
  customColumnName2: string;
  customColumnName3: string;
  customColumn1: string;
  customColumn2: string;
  customColumn3: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AnalystAthleteSite.cs
export interface AnalystAthleteSite extends AnalystAthlete {
  name: string;
  firstName: string;
  lastName: string;
  classYear?: number;
  jersey: string;
  heightInches?: number;
  heightFeet?: number;
  weight?: number;
  position1: string;
  position2: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\Rosters\AnalystPlayerCategorySp.cs
export interface AnalystPlayerCategorySp {
  categoryId: string;
  analystId: string;
  url: string;
  analystName: string;
  categoryName: string;
  athleteNotes: string;
  customColumn1: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\ContestWallItem.cs
export interface ContestWallItem {
  contest: ContestSubWallItem;
  tournament: TournamentWallItem;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\ContestWallItem.cs
export interface ContestSubWallItem {
  contestId: string;
  sportSeasonId: string;
  teams: ContestTeamWallItem[];
  hasResult: boolean;
  dateCode: DateCodes;
  date?: string;
  contestState: ContestState;
  allowReportFinalScore?: boolean;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\ContestWallItem.cs
export interface ContestTeamWallItem {
  teamId?: string;
  result?: string;
  score?: number;
  isTeamTba: boolean;
  isForfeit: boolean;
  homeAwayType: HomeAwayTypes;
  contestType: ContestTypes;
  name: string;
  schoolFormattedName: string;
  schoolNameAcronym: string;
  teamCanonicalUrl: string;
  mascotUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\ContestWallItem.cs
export interface TournamentWallItem {
  tournamentId: string;
  name: string;
  tournamentLogoImageUrl: string;
  tournamentCanonicalUrl: string;
  tournamentBracketId: string;
  bracketName: string;
  bracketLogoImageUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\MeetTheTeamWallItem.cs
export interface MeetTheTeamWallItem {
  teamPhotoUrl: string;
  staffList: TeamStaff[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\MeetTheTeamWallItem.cs
export interface TeamStaff {
  contactId: string;
  firstName: string;
  lastName: string;
  position: string;
  photoUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\PlayerOfTheWallItem.cs
export interface PlayerOfTheWallItem {
  athleteId: string;
  comments: string;
  badgeUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\RankingsWallItem.cs
export interface RankingsWallItem {
  rank: number;
  movement: string;
  rankingType: TeamRankingType;
  contextId: string;
  contextName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\RecordWallItem.cs
export interface RecordWallItem {
  overallStanding: OverallStanding;
  leagueStanding: LeagueStanding;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\StatsWallItem.cs
export interface StatsWallItem {
  name: string;
  value: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\TeamWallItemsList.cs
export interface TeamWallItemsList {
  key: string;
  teamId: string;
  sportSeasonId: string;
  startIndex: number;
  endIndex: number;
  wallItems: WallItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export interface WallItemLink {
  canonicalUrl: string;
  text: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export interface WallItemPhoto {
  photoUrl: string;
  canonicalUrl: string;
  width?: number;
  height?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export interface WallItem {
  type: WallItemType;
  dataSource: string;
  contentSource: ContentSource;
  title: string;
  text: string;
  textReplacements: Record<string, string>;
  timeStamp?: string;
  photos: WallItemPhoto[];
  links: WallItemLink[];
  canonicalUrl: string;
  isFixed: boolean;
  layoutType: LayoutType;
  data: any;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export interface ContentSource {
  contentSourceId: string;
  name: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export enum WallItemType {
  Generic = 0,
  Contest = 1,
  ScheduleCard = 2,
  Rankings = 3,
  Video = 4,
  Award = 5,
  NewSeason = 6,
  CoachNote = 7,
  TeamPreview = 8,
  Stats = 9,
  MeetTheTeam = 10,
  Record = 11,
  Contribution = 12,
  TeamLeaders = 13,
  TeamLeaderboardLeaders = 14
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\WallItem.cs
export enum LayoutType {
  Post = 0,
  Card = 1,
  Header = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\YearInfoWallItem.cs
export interface NewSeasonInfoWallItem extends YearInfoWallItem {
  hasSchedule: boolean;
  hasRoster: boolean;
  linksHeader: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\GatewayWeb\Models\WallItems\YearInfoWallItem.cs
export interface YearInfoWallItem {
  newSeasonYear: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Imports\Models\Import.cs
export interface Import {
  importId: string;
  personId: string;
  type: string;
  description: string;
  details: string;
  sportSeasonId: string;
  settings: string;
  submittedOn?: string;
  count?: number;
  completedCount?: number;
  isComplete: boolean;
  completedOn?: string;
  hasError: boolean;
  result: string;
  hasNotification: boolean;
  isTimeout: boolean;
  isImporting: boolean;
  loadedOn?: string;
  errorCount?: number;
  notificationCount?: number;
  hasFatalError: boolean;
  isResubmit: boolean;
  isPrepared: boolean;
  isCanceled: boolean;
  shouldUseImportName: boolean;
  source?: number;
  subSource?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Imports\Models\ImportData.cs
export interface ImportData {
  importDataId: string;
  importId: string;
  result: string;
  isTimedout: boolean;
  hasNotification: boolean;
  isComplete: boolean;
  hasError: boolean;
  importOrder?: number;
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
  field8: string;
  field9: string;
  field10: string;
  field11: string;
  field12: string;
  field13: string;
  field14: string;
  field15: string;
  field16: string;
  field17: string;
  field18: string;
  field19: string;
  field20: string;
  field21: string;
  field22: string;
  field23: string;
  field24: string;
  field25: string;
  field26: string;
  field27: string;
  field28: string;
  field29: string;
  field30: string;
  field31: string;
  field32: string;
  field33: string;
  field34: string;
  field35: string;
  field36: string;
  field37: string;
  field38: string;
  field39: string;
  field40: string;
  field41: string;
  field42: string;
  field43: string;
  field44: string;
  field45: string;
  field46: string;
  field47: string;
  field48: string;
  field49: string;
  field50: string;
  field51: string;
  field52: string;
  field53: string;
  field54: string;
  field55: string;
  field56: string;
  field57: string;
  field58: string;
  field59: string;
  field60: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Imports\Models\ImportDatasArray.cs
export interface ImportDatasArray {
  importId: string;
  importDatas: ImportData[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Leagues\Models\League.cs
export interface League {
  leagueId: string;
  name: string;
  sportSeasonId: string;
  sportSeasonName: string;
  stateId: string;
  stateCode: string;
  stateName: string;
  sectionId: string;
  sectionName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\Analyst.cs
export interface Analyst {
  analystId: string;
  name: string;
  url: string;
  graphicUrl: string;
  isActive: boolean;
  categoryCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\AnalystCategory.cs
export interface AnalystCategory {
  analystCategoryId: string;
  analystId: string;
  sportSeasonId: string;
  name: string;
  isActive: boolean;
  sort: number;
  customColumnName1: string;
  customColumnName2: string;
  customColumnName3: string;
  imageUrl: string;
  playerCategoryCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\AnalystPlayer.cs
export interface AnalystPlayer {
  analystPlayerId: string;
  analystId: string;
  analystCategoryId: string;
  athleteId: string;
  sportSeasonId: string;
  sort: number;
  team: string;
  customColumn1: string;
  customColumn2: string;
  customColumn3: string;
  isActive: boolean;
  athleteNotes: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\Athlete.cs
export interface Athlete {
  athleteId: string;
  firstName: string;
  lastName: string;
  classYear?: number;
  jersey: string;
  heightInches?: number;
  heightFeet?: number;
  weight?: number;
  position1: string;
  position2: string;
  position3: string;
  hasStats?: boolean;
  isCaptain: boolean;
  isDeleted?: boolean;
  photoUrl: string;
  secondaryPhotoUrl: string;
  weightClass?: number;
  isPlayerOfTheGame?: boolean;
  isFemale: boolean;
  bio: string;
  info: string;
  hasPhoto?: boolean;
  rosterId: string;
  schoolId: string;
  sportSeasonId: string;
  sportSeasonName: string;
  careerProfileId?: string;
  createdOn?: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\AthleteRoster.cs
export interface AccountInformation {
  createdByUserId?: string;
  createdOn?: string;
  firstLoginOn?: string;
  lastLoginOn?: string;
  createdByPosition: string;
  firstAppUsageOn?: string;
  firstAppPlatform: string;
  lastAppUsageOn?: string;
  lastAppPlatform: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\AthleteRoster.cs
export interface RosterAthlete extends Athlete {
  linkedAthlete: UserCareerRole;
  linkedParents: UserCareerRole[];
  hudlParticipantCount: number;
  hudlParticipantHighlightCount: number;
  canStartChat: boolean;
  accountInformation: AccountInformation;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\BaseAthlete.cs
export interface BaseAthlete {
  athleteId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\ParentRoster.cs
export interface Parent extends Contact {
  linkedAthletes: UserCareerRole[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\RosterActivityLog.cs
export interface RosterActivityLog {
  rosterActivityLogId: number;
  athleteId: string;
  schoolId: string;
  ssid: string;
  firstName: string;
  lastName: string;
  classYear?: number;
  isDeleted: boolean;
  jersey: string;
  heightFeet?: number;
  heightInches?: number;
  weight?: number;
  photoUrl: string;
  position1: string;
  position2: string;
  position3: string;
  info: string;
  hasStats: boolean;
  isCaptain: boolean;
  weightClass?: number;
  isPlayerOfGame: boolean;
  isFemale: boolean;
  careerProfileId?: string;
  secondaryPhotoUrl: string;
  userId: string;
  userFirstName: string;
  userLastName: string;
  processingUserId: string;
  authenticatedRoleId: string;
  activitySource: number;
  activitySourceName: string;
  activitySubSource?: number;
  activitySubSourceName: string;
  activityType: number;
  activityTypeName: string;
  activitySubType?: number;
  activitySubTypeName: string;
  importId: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\RosterCounts.cs
export interface RosterCounts {
  teamId: string;
  sportSeasonId: string;
  athleteCount: number;
  parentCount: number;
  staffCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\SportSeasonsRosterCounts.cs
export interface SportSeasonsRosterCounts {
  allSeasonId: string;
  teamId: string;
  counts: RosterCount[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\SportSeasonsRosterCounts.cs
export interface RosterCount {
  sportSeasonId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Rosters\Models\StaffRoster.cs
export interface Staff extends Contact {}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\CoachInfo.cs
export interface CoachInfo {
  coachName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\Dma.cs
export interface Dma {
  dmaId: string;
  name: string;
  code: number;
  type: string;
  isPublished: boolean;
  url: string;
  lastSportUpdateOn?: string;
  stateCode: string;
  rankingsCanonicalUrl: string;
  scoreboardCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\Enums.cs
export enum SchoolSearchSortOrder {
  None = 0,
  Name = 1,
  Distance = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\LeanSchool.cs
export interface LeanSchool {
  schoolId: string;
  isDeleted?: boolean;
  isPseudoSchool: boolean;
  name: string;
  address: string;
  city: string;
  zip: string;
  zipCode: string;
  mascot: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  colorName1: string;
  colorName2: string;
  colorName3: string;
  colorName4: string;
  isImported?: boolean;
  searchName: string;
  gender: string;
  mailingAddress: string;
  mailingAddress2: string;
  mailingAddressNote: string;
  mailingCity: string;
  mailingState: string;
  mailingZip: string;
  phone: string;
  type: string;
  latitude: number;
  longitude: number;
  utcOffset: number;
  dstOffset: number;
  timeZoneId: string;
  athleticDirectorName: string;
  isFootballMascotHelmetAvailable?: boolean;
  url: string;
  websiteUrl: string;
  fullName: string;
  additionalInfo: string;
  address2: string;
  addressNote: string;
  enrollment?: number;
  isHistoricalOnly: boolean;
  importName: string;
  isNameUnique: boolean;
  mapUrl: string;
  phoneNote: string;
  mascotUrl: string;
  mascotUploadedOn?: string;
  stateId: string;
  state: string;
  stateCode: string;
  stateName: string;
  prepSportswearId?: number;
  formattedName: string;
  formattedNameWithoutState: string;
  shouldAppendHighSchoolString: boolean;
  nameAcronym: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\RewrittenSchoolNames.cs
export interface RewrittenSchoolNames {
  version: number;
  hash: string;
  xml: number[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\School.cs
export interface School extends LeanSchool {
  associationId: string;
  associationName: string;
  associationGoverningBodyName: string;
  associationGoverningBodyUrl: string;
  associationGoverningBodyImageUrl: string;
  associationGoverningBodyImageWidth: number;
  associationGoverningBodyImageHeight: number;
  associationGoverningBodyAbbreviation: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SchoolLeague.cs
export interface SchoolLeague {
  schoolId: string;
  sportSeasonId: string;
  leagueId: string;
  isSecondary: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SchoolMascotPhoto.cs
export interface SchoolMascotPhoto {
  url: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SchoolSection.cs
export interface SchoolSection {
  schoolSectionId: string;
  schoolId: string;
  sectionId: string;
  coachName: string;
  playerCount: number;
  sportSeasonId: string;
  sectionTypeId: string;
  sectionLevel: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SchoolSportSeason.cs
export interface SchoolSportSeason extends SportSeason {
  schoolId: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SchoolSportSeasonsWithSchool.cs
export interface SchoolSportSeasonsWithSchool {
  school: School;
  valueMap: any;
  sportSeasons: SportSeason[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\SportSeasonValueMap.cs
export interface SportSeasonValueMap {
  genderId: string;
  gender: string;
  sportId: string;
  sport: string;
  teamLevelid: string;
  teamLevel: string;
  seasonId: string;
  season: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Schools\Models\WallPost.cs
export interface WallPost {
  wallPostId: string;
  schoolId: string;
  isFile?: boolean;
  subject: string;
  fileTitle: string;
  fileExtension: string;
  url: string;
  urlTitle: string;
  postedOn?: string;
  updatedOn?: string;
  details: string;
  isPrivate?: boolean;
  creatorName: string;
  modifierName: string;
  creatorRoleId: string;
  modifierRoleId: string;
  creatorUserId?: string;
  modifierUserId?: string;
  hasAttachment: boolean;
  attachmentName: string;
  attachmentUrl: string;
  hasLink: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Sections\Models\Sections.cs
export interface Section {
  sectionId: string;
  name: string;
  sportSeasonId: string;
  sportSeasonName: string;
  stateId: string;
  stateCode: string;
  stateName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Site\Models\SiteBool.cs
export interface SiteBool {
  isSuccessful: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Site\Models\SiteGuid.cs
export interface SiteGuid {
  id: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Site\Contacts\Models\CreatedContactInfo.cs
export interface CreatedContactInfo {
  contactId: string;
  schoolId: string;
  sportSeasonId: string;
  createdByUserId: string;
  isValid: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Site\Contacts\Models\SiteContact.cs
export interface SiteContact {
  contactId: string;
  userId: string;
  roleId: string;
  accessId1?: string;
  accessId2?: string;
  position: string;
  title: string;
  loginCode: string;
  source: string;
  accessNote: string;
  createdByUserId?: string;
  createdOn?: string;
  firstLoginOn?: string;
  lastLoginOn?: string;
  createdByPosition: string;
  firstAppUsageOn?: string;
  firstAppPlatform: string;
  lastAppUsageOn?: string;
  lastAppPlatform: string;
  adminRolePermissionIds: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Standings\Models\Standings.cs
export interface Standing {
  standingsId: string;
  points: number;
  pointsAgainst: number;
  conferencePoints: number;
  conferencePointsAgainst: number;
  overallWins: number;
  overallLosses: number;
  overallTies: number;
  conferenceWins: number;
  conferenceLosses: number;
  conferenceTies: number;
  conferenceTournamentWins: number;
  conferenceTournamentLosses: number;
  conferenceTournamentTies: number;
  homeWins: number;
  homeLosses: number;
  homeTies: number;
  awayWins: number;
  awayLosses: number;
  awayTies: number;
  neutralWins: number;
  neutralLosses: number;
  neutralTies: number;
  winningPercentage: number;
  conferenceWinningPercentage: number;
  volleyballBestOf5Wins: number;
  volleyballBestOf3Wins: number;
  volleyballBestOf5Losses: number;
  volleyballBestOf3Losses: number;
  volleyballBestOf5Ties: number;
  volleyballBestOf3Ties: number;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
  streak: number;
  streakResult: string;
  firstPlace?: number;
  secondPlace?: number;
  thirdPlace?: number;
  createdOn?: string;
  modifiedOn?: string;
  schoolId: string;
  schoolName: string;
  schoolFormattedName: string;
  schoolFormattedNameWithoutState: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
  schoolMascotUrl: string;
  schoolNameAcronym: string;
  sportSeasonId: string;
  teamCanonicalUrl: string;
  overallContestsPlayed: number;
  conferenceContestsPlayed: number;
  overallStandingPlacement?: number;
  conferenceStandingPlacement?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\States\Models\StateNomination.cs
export interface StateNomination {
  stateNominationId: string;
  teamId: string;
  sportSeasonId: string;
  athleteId: string;
  createdOn: string;
  modifiedOn: string;
  honors: string;
  nominatorFirstName: string;
  nominatorLastName: string;
  nominatorEmail: string;
  rank?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\AthleteLeaderboardLeader.cs
export interface AthleteLeaderboardLeader {
  currentRank: number;
  careerId: string;
  teamId: string;
  sportSeasonId: string;
  contextId: string;
  statField: number;
  currentValue: number;
  contextType: LeaderboardContextType;
  teamSize: number;
  grade?: number;
  position: string;
  nationalAverage: number;
  contextAverage: number;
  minimums: LeaderboardStat[];
  contextualStats: LeaderboardStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\AthleteLeaderboardLeader.cs
export interface LeaderboardStat {
  sFieldNumber: number;
  displayName: string;
  header: string;
  value: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\BaseStat.cs
export interface BaseStat {
  stats: StatDisplay[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteCareerOverride.cs
export interface StatAthleteCareerOverride extends BaseStat {
  statAthleteCareerOverrideId: string;
  careerProfileId: string;
  allSeasonId: string;
  gamesPlayed?: number;
  createdOn: string;
  modifiedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteCareerRollup.cs
export interface StatAthleteCareerRollup extends BaseStat {
  statAthleteCareerRollupId: string;
  careerProfileId: string;
  allSeasonId: string;
  gamesPlayed?: number;
  createdOn: string;
  modifiedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteContest.cs
export interface StatAthleteContest extends BaseStat {
  statAthleteContestId: string;
  sportSeasonId: string;
  leagueId?: string;
  schoolId?: string;
  athleteId: string;
  contestId?: string;
  date?: string;
  contestType?: number;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteContestInput.cs
export interface StatAthleteContestInput {
  statAthleteContestId: string;
  sportSeasonId: string;
  schoolId?: string;
  athleteId: string;
  contestId?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  s1?: number;
  s2?: number;
  s3?: number;
  s4?: number;
  s5?: number;
  s6?: number;
  s7?: number;
  s8?: number;
  s9?: number;
  s10?: number;
  s11?: number;
  s12?: number;
  s13?: number;
  s14?: number;
  s15?: number;
  s16?: number;
  s17?: number;
  s18?: number;
  s19?: number;
  s20?: number;
  s21?: number;
  s22?: number;
  s23?: number;
  s24?: number;
  s25?: number;
  s26?: number;
  s27?: number;
  s28?: number;
  s29?: number;
  s30?: number;
  s31?: number;
  s32?: number;
  s33?: number;
  s34?: number;
  s35?: number;
  s36?: number;
  s37?: number;
  s38?: number;
  s39?: number;
  s40?: number;
  s41?: number;
  s42?: number;
  s43?: number;
  s44?: number;
  s45?: number;
  s46?: number;
  s47?: number;
  s48?: number;
  s49?: number;
  s50?: number;
  s51?: number;
  s52?: number;
  s53?: number;
  s54?: number;
  s55?: number;
  s56?: number;
  s57?: number;
  s58?: number;
  s59?: number;
  s60?: number;
  s61?: number;
  s62?: number;
  s63?: number;
  s64?: number;
  s65?: number;
  s66?: number;
  s67?: number;
  s68?: number;
  s69?: number;
  s70?: number;
  s71?: number;
  s72?: number;
  s73?: number;
  s74?: number;
  s75?: number;
  s76?: number;
  s77?: number;
  s78?: number;
  s79?: number;
  s80?: number;
  s81?: number;
  s82?: number;
  s83?: number;
  s84?: number;
  s85?: number;
  s86?: number;
  s87?: number;
  s88?: number;
  s89?: number;
  s90?: number;
  s91?: number;
  s92?: number;
  s93?: number;
  s94?: number;
  s95?: number;
  s96?: number;
  s97?: number;
  s98?: number;
  s99?: number;
  s100?: number;
  s101?: number;
  s102?: number;
  s103?: number;
  s104?: number;
  s105?: number;
  s106?: number;
  s107?: number;
  s108?: number;
  s109?: number;
  s110?: number;
  s111?: number;
  s112?: number;
  s113?: number;
  s114?: number;
  s115?: number;
  s116?: number;
  s117?: number;
  s118?: number;
  s119?: number;
  s120?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteLeader.cs
export interface StatAthleteLeader {
  sportSeasonId: string;
  group: string;
  subGroup: string;
  teamSize?: number;
  sortFields: string;
  count: number;
  totalCount: number;
  minimums: string[];
  leaders: StatAthleteLeaderStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteLeader.cs
export interface StatAthleteLeaderStat extends BaseStat {
  rowNumber: number;
  teamId: string;
  athleteId: string;
  careerProfileId: string;
  gamesPlayed?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteLeagueRollup.cs
export interface StatAthleteLeagueRollup extends BaseStat {
  statAthleteLeagueRollupId: string;
  sportSeasonId: string;
  leagueId: string;
  schoolId: string;
  athleteId: string;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteNationalAverage.cs
export interface StatAthleteNationalAverage extends BaseStat {
  sportSeasonId: string;
  gamesPlayed?: number;
  createdModifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteSeasonRollup.cs
export interface StatAthleteSeasonRollup extends BaseStat {
  statAthleteSeasonRollupId: string;
  sportSeasonId: string;
  leagueId?: string;
  schoolId: string;
  athleteId: string;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteStateAverage.cs
export interface StatAthleteStateAverage extends BaseStat {
  sportSeasonId: string;
  stateId: string;
  gamesPlayed?: number;
  createdModifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteStd.cs
export interface StatAthleteStd extends BaseStat {
  statAthleteStdId: string;
  sportSeasonId: string;
  leagueId?: string;
  schoolId?: string;
  athleteId: string;
  stdOn?: string;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatAthleteTournamentRollup.cs
export interface StatAthleteTournamentRollup extends BaseStat {
  statAthleteTournamentRollupId: string;
  sportSeasonId: string;
  schoolId: string;
  tournamentId: string;
  athleteId: string;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatContestOcrResult.cs
export interface StatContestOcrResult {
  headers: string[];
  csvString: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatDescriptionList.cs
export interface StatDescriptionList {
  allSeasonId: string;
  groups: StatDescriptionGroup[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatDescriptionList.cs
export interface StatDescriptionGroup {
  name: string;
  subGroups: StatDescriptionSubGroup[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatDescriptionList.cs
export interface StatDescriptionSubGroup {
  name: string;
  stats: StatDescriptionStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatDescriptionList.cs
export interface StatDescriptionStat {
  header: string;
  name: string;
  description: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatDisplay.cs
export interface StatDisplay {
  name: string;
  displayName: string;
  header: string;
  value: string;
  field: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatLeaderRequest.cs
export interface StatLeaderRequest {
  context: StatLeaderContext;
  leadersDefinitionGroupName: string;
  leadersDefinitionSubGroupName: string;
  featuredLeadersStatsOnly: boolean;
  sportSeasonId: string;
  teamId?: string;
  leagueId?: string;
  sectionId?: string;
  divisionId?: string;
  associationId?: string;
  stateCode: string;
  isLeague: boolean;
  primarySort: string;
  count: number;
  startIndex: number;
  teamSize?: number;
  position: string;
  classYear?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamContestOverride.cs
export interface StatTeamContestOverride extends BaseStat {
  statTeamContestOverrideId: string;
  sportSeasonId: string;
  leagueId?: string;
  contestId?: string;
  schoolId: string;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamContestRollup.cs
export interface StatTeamContestRollup extends BaseStat {
  statTeamContestRollupId: string;
  sportSeasonId: string;
  leagueId?: string;
  contestId?: string;
  schoolId: string;
  stdOn?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  contestType?: number;
  date?: string;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamLeader.cs
export interface StatTeamLeader {
  sportSeasonId: string;
  group: string;
  subGroup: string;
  teamSize?: number;
  sortFields: string;
  count: number;
  totalCount: number;
  minimums: string[];
  leaders: StatTeamLeaderStat[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamLeader.cs
export interface StatTeamLeaderStat extends BaseStat {
  rowNumber: number;
  teamId: string;
  gamesPlayed?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamLeagueRollup.cs
export interface StatTeamLeagueRollup extends BaseStat {
  statTeamLeagueRollupId: string;
  sportSeasonId: string;
  leagueId: string;
  schoolId: string;
  stdOn?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamNationalAverage.cs
export interface StatTeamNationalAverage extends BaseStat {
  sportSeasonId: string;
  gamesPlayed?: number;
  createdModifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamSeasonRollup.cs
export interface StatTeamSeasonRollup extends BaseStat {
  statTeamSeasonRollupId: string;
  sportSeasonId: string;
  leagueId: string;
  schoolId: string;
  stdOn?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamStateAverage.cs
export interface StatTeamStateAverage extends BaseStat {
  sportSeasonId: string;
  stateId: string;
  gamesPlayed?: number;
  createdModifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamStdOverride.cs
export interface StatTeamStdOverride extends BaseStat {
  statTeamStdOverrideId: string;
  sportSeasonId: string;
  leagueId?: string;
  schoolId: string;
  stdOn?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamStdRollup.cs
export interface StatTeamStdRollup extends BaseStat {
  statTeamStdRollupId: string;
  sportSeasonId: string;
  leagueId: string;
  schoolId: string;
  stdOn?: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatTeamTournamentRollup.cs
export interface StatTeamTournamentRollup extends BaseStat {
  statTeamTournamentRollupId: string;
  sportSeasonId: string;
  tournamentId: string;
  schoolId: string;
  gamesPlayed?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Models\StatLogs\TeamContestRollupStatsLogs.cs
export interface TeamContestRollupStatsLog {
  teamContestRollupStatsLogId: string;
  createdOn: string;
  teamId: string;
  sportSeasonId: string;
  allSeasonId: string;
  contestId: string;
  userId: string;
  activitySource: number;
  activitySubSource: number;
  s1?: number;
  s2?: number;
  s3?: number;
  s4?: number;
  s5?: number;
  s6?: number;
  s7?: number;
  s8?: number;
  s9?: number;
  s10?: number;
  s11?: number;
  s12?: number;
  s13?: number;
  s14?: number;
  s15?: number;
  s16?: number;
  s17?: number;
  s18?: number;
  s19?: number;
  s20?: number;
  s21?: number;
  s22?: number;
  s23?: number;
  s24?: number;
  s25?: number;
  s26?: number;
  s27?: number;
  s28?: number;
  s29?: number;
  s30?: number;
  s31?: number;
  s32?: number;
  s33?: number;
  s34?: number;
  s35?: number;
  s36?: number;
  s37?: number;
  s38?: number;
  s39?: number;
  s40?: number;
  s41?: number;
  s42?: number;
  s43?: number;
  s44?: number;
  s45?: number;
  s46?: number;
  s47?: number;
  s48?: number;
  s49?: number;
  s50?: number;
  s51?: number;
  s52?: number;
  s53?: number;
  s54?: number;
  s55?: number;
  s56?: number;
  s57?: number;
  s58?: number;
  s59?: number;
  s60?: number;
  s61?: number;
  s62?: number;
  s63?: number;
  s64?: number;
  s65?: number;
  s66?: number;
  s67?: number;
  s68?: number;
  s69?: number;
  s70?: number;
  s71?: number;
  s72?: number;
  s73?: number;
  s74?: number;
  s75?: number;
  s76?: number;
  s77?: number;
  s78?: number;
  s79?: number;
  s80?: number;
  s81?: number;
  s82?: number;
  s83?: number;
  s84?: number;
  s85?: number;
  s86?: number;
  s87?: number;
  s88?: number;
  s89?: number;
  s90?: number;
  s91?: number;
  s92?: number;
  s93?: number;
  s94?: number;
  s95?: number;
  s96?: number;
  s97?: number;
  s98?: number;
  s99?: number;
  s100?: number;
  s101?: number;
  s102?: number;
  s103?: number;
  s104?: number;
  s105?: number;
  s106?: number;
  s107?: number;
  s108?: number;
  s109?: number;
  s110?: number;
  s111?: number;
  s112?: number;
  s113?: number;
  s114?: number;
  s115?: number;
  s116?: number;
  s117?: number;
  s118?: number;
  s119?: number;
  s120?: number;
  s121?: number;
  s122?: number;
  s123?: number;
  s124?: number;
  s125?: number;
  s126?: number;
  s127?: number;
  s128?: number;
  s129?: number;
  s130?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\AccessCodeTeamRef.cs
export interface AccessCodeTeamRef {
  accessCodeId: string;
  teamId: string;
  allSeasonId: string;
  passwordWarning: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\AllSeasonTeam.cs
export interface AllSeasonTeam {
  teamId: string;
  allSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\BaseTeam.cs
export interface BaseTeam {
  teamId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\GameChangerRef.cs
export interface GameChangerRef {
  gameChangerRefId: string;
  teamId: string;
  sportSeasonId: string;
  gameChangerTeamId: string;
  createdOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\LeanTeam.cs
export interface LeanTeam extends BaseTeam {
  isDeleted: boolean;
  schoolName: string;
  schoolFormattedName: string;
  schoolCity: string;
  state: string;
  stateCode: string;
  sportSeasonName: string;
  gender: string;
  sport: string;
  season: string;
  level: string;
  year: string;
  formattedSportSeasonName: string;
  coachName: string;
  teamSize: number;
  sectionId: string;
  sectionName: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\Menu.cs
export interface Menu {
  teamId: string;
  sportSeasonId: string;
  items: MenuItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\MenuItem.cs
export interface MenuItem {
  text: string;
  adminUrl: string;
  publicUrl: string;
  adminLoginUrl: string;
  openInPopup: boolean;
  roles: MenuRole[];
  subMenu: MenuItem[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\MenuRole.cs
export interface MenuRole {
  role: string;
  permissions: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\NationalSchoolRank.cs
export interface NationalSchoolRank {
  schoolId: string;
  rank: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\RankingMinimums.cs
export interface RankingMinimums {
  sportSeasonId: string;
  minimum?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\RankingTypeData.cs
export interface RankingTypeData {
  rank: number;
  movement: string;
  rankingType: TeamRankingType;
  contextId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\SectionDivisionRef.cs
export interface SectionDivisionRef {
  sectionDivisionRefId: string;
  sportSeasonId: string;
  teamId: string;
  divisionId: string;
  sectionId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\StateDivisionRef.cs
export interface StateDivisionRef {
  stateDivisionRefId: string;
  sportSeasonId: string;
  teamId: string;
  divisionId: string;
  state: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\Team.cs
export interface Team extends LeanTeam {
  schoolAddress: string;
  schoolZipCode: string;
  schoolMascot: string;
  schoolMascotUrl: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolMailingAddress: string;
  schoolMailingAddress2: string;
  schoolMailingAddressNote: string;
  schoolMailingCity: string;
  schoolMailingState: string;
  schoolMailingZip: string;
  schoolPhone: string;
  schoolCanonicalUrl: string;
  stateId: string;
  stateName: string;
  allSeasonId: string;
  leagueId: string;
  leagueName: string;
  leagueCanonicalUrl: string;
  stateDivisionId: string;
  stateDivisionName: string;
  sectionDivisionId: string;
  sectionDivisionName: string;
  schoolAssociationId: string;
  schoolAssociationName: string;
  schoolAssociationGoverningBodyName: string;
  schoolAssociationGoverningBodyUrl: string;
  schoolAssociationGoverningBodyAbbreviation: string;
  schoolShouldAppendHighSchoolString: boolean;
  schoolNameAcronym: string;
  stateNominationStartsOn?: string;
  stateNominationEndsOn?: string;
  stateNominationBodyName: string;
  stateNominationBodyAbbreviation: string;
  stateQualificationStartsOn?: string;
  stateQualificationEndsOn?: string;
  stateQualificationBodyName: string;
  stateQualificationBodyAbbreviation: string;
  isGameChangerConnected: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamDataAvailability.cs
export interface TeamDataAvailability {
  teamId: string;
  sportSeasonId: string;
  hasTeamRoster: boolean;
  hasAnyTeamRoster: boolean;
  hasContests: boolean;
  hasLeagueStandings: boolean;
  hasStats: boolean;
  hasRankings: boolean;
  hasVideos: boolean;
  hasProPhotos: boolean;
  hasArticles: boolean;
  isPrepsSportsEnabled: boolean;
  updatedOn: string;
  hasMaxprepsTeamPreview: boolean;
  hasImportedTeamPreview: boolean;
  maxprepsTeamPreviewCreatedOn?: string;
  maxprepsTeamPreviewModifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamRanking.cs
export interface TeamRanking {
  teamRankingId: string;
  rankingType: TeamRankingType;
  schoolId?: string;
  sportSeasonId?: string;
  leagueId?: string;
  sectionId?: string;
  stateDivisionId?: string;
  sectionDivisionId?: string;
  dmaId?: string;
  league: string;
  section: string;
  state: string;
  rank?: number;
  isScraper: boolean;
  version?: number;
  teamSize?: number;
  strength?: number;
  rating?: number;
  movement: string;
  overallRecord: string;
  leagueRecord: string;
  createdOn?: string;
  notifiedOn?: string;
  isNational?: boolean;
  hasMovement: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamRanking.cs
export enum TeamRankingType {
  National = 0,
  State = 1,
  Section = 2,
  SectionDivision = 3,
  StateDivision = 4,
  Association = 5,
  DMA = 6,
  Xcellent = 7,
  Unknown = 8
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamRankingContextRef.cs
export interface TeamRankingContextRef {
  schoolId: string;
  sportSeasonId: string;
  rankingType: TeamRankingType;
  rank: number;
  contextId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamRankingSummary.cs
export interface TeamRankingSummary {
  createdOn?: string;
  leagueRecord: string;
  overallRecord: string;
  rating?: number;
  strength?: number;
  teamSize?: number;
  version?: number;
  isScraper: boolean;
  state: string;
  section: string;
  league: string;
  sectionDivisionId?: string;
  stateDivisionId?: string;
  sectionId?: string;
  leagueId?: string;
  sportSeasonId: string;
  schoolId: string;
  notifiedOn?: string;
  hasMovement: boolean;
  dmaId?: string;
  typeData: RankingTypeData[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamSettings.cs
export interface TeamSettings {
  teamId: string;
  sportSeasonId: string;
  areVolunteersDisallowed: boolean;
  rosterUpdatedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamVolunteerRequest.cs
export interface TeamVolunteerRequestForCoach extends TeamVolunteerRequest {
  volunteerFirstName: string;
  volunteerLastName: string;
  volunteerEmail: string;
  volunteerMembershipRole: string;
  volunteerPhotoUrl: string;
  coachFirstName: string;
  coachLastName: string;
  coachEmail: string;
  coachMembershipRole: string;
  coachPhotoUrl: string;
  approveUrl: string;
  denyUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamVolunteerRequest.cs
export interface TeamVolunteerRequest {
  teamVolunteerRequestId: string;
  teamId: string;
  sportSeasonId: string;
  allSeasonId?: string;
  createdOn: string;
  modifiedOn: string;
  volunteerMembershipId: string;
  coachMembershipId: string;
  status: string;
  volunteerContactId?: string;
  coachContactId?: string;
  volunteerComments: string;
  contactCreatedOn?: string;
  error: string;
  contactDeniedOn?: string;
  contactApprovedOn?: string;
  volunteerMemberWasCreated?: boolean;
  volunteerContactWasCreated?: boolean;
  coachMemberWasCreated?: boolean;
  coachContactWasCreated?: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Teams\Models\TeamWallPost.cs
export interface TeamWallPost extends WallPost {
  allSeasonId: string;
  season: string;
  gender: string;
  sport: string;
  teamLevel: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Tournaments\Models\TournamentOrganization.cs
export interface TournamentOrganization {
  tournamentOrganizationId: string;
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\BasicUser.cs
export interface BasicUser extends LeanUser {
  email: string;
  publicUserId?: string;
  name: string;
  comment: string;
  registrationSource: string;
  acceptedScoreCount: number;
  contributionLabel: number;
  lastSubmittedScoreOn: number;
  submittedScoreCount: number;
  failedPasswordAttemptCount: number;
  createdOn?: string;
  lastLoginOn?: string;
  lastPasswordChangedOn?: string;
  lastLockoutOn?: string;
  lastLoginAttemptOn?: string;
  deactivaedOn?: string;
  isApproved: boolean;
  isLocked: boolean;
  isContributionAllowed: boolean;
  isSystemAccount: boolean;
  isMember: boolean;
  password: string;
  confirmPassword: string;
  referredById: string;
  registrationDate?: string;
  userSource: string;
  lastWebLoginOn?: string;
  firstMpAppLaunchedOn?: string;
  lastMpAppLaunchedOn?: string;
  lastMpAppPlatform: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\LeanUser.cs
export interface LeanUser {
  userId: string;
  firstName: string;
  lastName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  stateCode: string;
  zip: string;
  zipCode: string;
  country: string;
  phone: string;
  fax: string;
  bornOn?: string;
  gender: Gender;
  lastUpdatedOn: string;
  stateByZipCode: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\LoginRequest.cs
export interface LoginRequest {
  email: string;
  password: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\Role.cs
export interface Role {
  personId: string;
  userId: string;
  accessId1?: string;
  accessId2?: string;
  roleId: string;
  roleName: string;
  createdByUserId?: string;
  createdByPosition: string;
  createdOn?: string;
  source: string;
  position: string;
  permissions: RolePermission[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\RolePermission.cs
export interface RolePermission {
  permissionId: string;
  identifier: string;
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\SubscriptionEligibilityRule.cs
export interface SubscriptionEligibilityRule {
  subscriptionEligibilityRuleId: number;
  rulesetId: number;
  ruleType: string;
  ruleValue: string;
  ruleValueAlt: string;
  createdOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\SubscriptionEligibilityRuleset.cs
export interface SubscriptionEligibilityRuleset {
  subscriptionEligibilityRulesetId: number;
  categoryId: string;
  rulesetName: string;
  evaluateOrder: number;
  createdOn: string;
  updatedOn: string;
  subscriptionEligibilityRules: SubscriptionEligibilityRule[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\SubscriptionTopic.cs
export interface SubscriptionTopic {
  subscriptionTopicId: string;
  categoryId: string;
  displayName: string;
  systemName: string;
  isEnabled: boolean;
  displayOrder?: number;
  createdOn: string;
  updatedOn: string;
  description: string;
  isFeatured: boolean;
  bannerImageUrl: string;
  previewImageUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\User.cs
export interface User extends BasicUser {
  isArmyNationalGuard: boolean;
  hasOptedSchoolUpdatesEmail: boolean;
  hasOptedMaxPrepsUpdatesEmail: boolean;
  hasOptedOutFromEmail: boolean;
  type: string;
  timeZone: string;
  schoolId?: string;
  isGraduated: boolean;
  graduatedOn?: string;
  educationLevel: string;
  widgetTeamMaxCount: number;
  isAllowedGeneratedImages: boolean;
  hasOptedCampaignSubscriptionEmail: boolean;
  isInBeRecruited: boolean;
  sport: string;
  hasOptedNcsa: boolean;
  hasOptedZinch: boolean;
  optedAngOn?: string;
  optedNcsaOn?: string;
  angOptInSource: string;
  hasOptedAdAndCoachAnnouncements: boolean;
  hasOptedAdAndCoachReminders: boolean;
  hasOptedStateAssociationMessaging: boolean;
  optedThscaOn?: string;
  angTransmitionOn?: string;
  optedCifOn?: string;
  optedNmaaOn?: string;
  optedAiaOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserFavoriteCareerProfileRef.cs
export interface UserFavoriteCareerProfileRef {
  userId: string;
  careerProfileId: string;
  careerProfileFirstName: string;
  careerProfileLastName: string;
  graduatingClass?: number;
  photoUrl: string;
  schoolId?: string;
  schoolName: string;
  schoolFormattedName: string;
  schoolNameAcronym: string;
  schoolCity: string;
  schoolState: string;
  schoolMascot: string;
  schoolMascotUrl: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserFavoriteTeamNotificationSetting.cs
export interface UserFavoriteTeamNotificationSetting {
  userFavoriteTeamNotificationSettingId: number;
  userFavoriteTeamId: number;
  name: string;
  shortName: string;
  sortOrder: number;
  isEnabledForApp: boolean;
  isEnabledForEmail: boolean;
  isEnabledForSms: boolean;
  isEnabledForWeb: boolean;
  isVisibleForEmail: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserFavoriteTeamRef.cs
export interface UserFavoriteTeamRef {
  userFavoriteTeamRefId: number;
  userId: string;
  schoolId: string;
  allSeasonId: string;
  seasonName: string;
  source: string;
  sectionId?: string;
  schoolName: string;
  schoolCity: string;
  schoolMascot: string;
  schoolMascotUrl: string;
  stateCode: string;
  gender: string;
  sport: string;
  level: string;
  schoolColor1: string;
  schoolColor2: string;
  schoolColor3: string;
  schoolColor4: string;
  schoolFormattedName: string;
  schoolNameAcronym: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserForEditing.cs
export interface UserForEditing extends User {
  passwordHash: string;
  passwordSalt: string;
  state: string;
  zip: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserPasswordInfo.cs
export interface UserPasswordInfo {
  userId: string;
  passwordHash: string;
  passwordSalt: string;
  isLockedOut: boolean;
  failedPasswordAttemptCount: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserQwixcoreProfile.cs
export interface UserQwixcoreProfile {
  userId: string;
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  cellPhone: string;
  cellProvider: string;
  hasProfilePhoto: boolean;
  twitterHandle: string;
  facebookUrl: string;
  association: string;
  associationUrl: string;
  referredBy: string;
  isActive: boolean;
  mp360: boolean;
  createdOn: string;
  modifiedOn: string;
  isOfficialScoreReporter: boolean;
  submittedScoreCount: number;
  acceptedScoreCount: number;
  calculatedScoreRating: number;
  lastSubmittedScoreOn?: string;
  sendTextMessage: boolean;
  scoringRole: string;
  isFirstTimeScorer: boolean;
  allowFullNameAttribution: boolean;
  isQualityScorer: boolean;
  qualityGames: number;
  lastQualityGameOn?: string;
  assignedGames: number;
  shirtSize: string;
  profilePhotoApprovedBy?: string;
  profilePhotoApprovedOn?: string;
  bio: string;
  photoUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserViewPrivacyPortal {
  email: string;
  user: UserInfoPrivacyPortal;
  roles: UserRolePrivacyPortal[];
  favoriteTeams: UserFavoriteTeamPrivacyPortal[];
  favoriteAthletes: UserFavoriteCareerPrivacyPortal[];
  claimedProfiles: UserClaimProfilePrivacyPortal[];
  subscriptions: UserSubscriptionPrivacyPortal[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserInfoPrivacyPortal {
  email: string;
  firstName: string;
  lastName: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  fax: string;
  gender: string;
  type: string;
  educationLevel: string;
  createdOn?: string;
  lastLoginOn?: string;
  bornOn?: string;
  graduatedOn?: string;
  lastUpdatedOn?: string;
  isGraduated: boolean;
  isMember: boolean;
  registrationDate?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserRolePrivacyPortal {
  roleName: string;
  roleInformation: string;
  position: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserFavoriteTeamPrivacyPortal {
  school: string;
  team: string;
  notifications: UserFavoriteTeamNotificationPrivacyPortal[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserFavoriteTeamNotificationPrivacyPortal {
  name: string;
  enabled: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserFavoriteCareerPrivacyPortal {
  athleteFirstName: string;
  athleteLastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserClaimProfilePrivacyPortal {
  athleteFirstName: string;
  athleteLastName: string;
  relationship: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Models\UserViewPrivacyPortal.cs
export interface UserSubscriptionPrivacyPortal {
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SiteSwitches\Models\SiteSwitch.cs
export interface SiteSwitch {
  siteSwitchId: string;
  name: string;
  customHtml: string;
  description: string;
  featurePermissionsAcl: string[];
  lastModifiedBy: string;
  lastModifiedOn?: string;
  purgeUrIs: string[];
  isEnabled: boolean;
  hasCustomHtml: boolean;
  status: SiteSwitchStatus;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SiteSwitches\Models\SiteSwitches.cs
export interface SiteSwitches {}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SiteSwitches\Models\SiteSwitchStatus.cs
export enum SiteSwitchStatus {
  DoesntExist = 0,
  Enabled = 1,
  Disabled = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SlideShows\Models\PromoItem.cs
export interface PromoItem {
  promoItemId: string;
  clickUrl: string;
  title: string;
  caption: string;
  publishedOn: string;
  photoCredit: string;
  photoCreditClickUrl: string;
  photoSourceUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\UrlRewriterServiceClient\Models\UrlRewriteCache.cs
export interface UrlRewriteCache {
  formattedUrl: string;
  intentionalNonRewrite: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideo.cs
export interface ElasticVideo {
  id: string;
  userId?: string;
  itemtype: number;
  viewsStamp: string;
  youTubeVideoId: string;
  sourceCategoryId: string;
  duration: number;
  formattedDuration: string;
  createdDate?: string;
  lastModifiedDate: string;
  publishDate?: string;
  formattedPublishDate: string;
  isInternalVideo: boolean;
  inProduction: boolean;
  isReviewed: boolean;
  viewCount?: number;
  title: string;
  description: string;
  keywords: string;
  mpxId: string;
  canId: string;
  externalVideoUrl: string;
  externalPartner: string;
  externalPartnerVideoId: string;
  thumbnails: ElasticVideoThumbnail[];
  renditions: ElasticVideoRendition[];
  thumbnail: ElasticVideoThumbnail;
  categories: ElasticVideoCategory[];
  references: ElasticVideoReferences;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoReferences {
  athletes: ElasticVideoAthleteReference[];
  careers: ElasticVideoCareerReference[];
  contests: ElasticVideoContestReference[];
  leagues: ElasticVideoLeagueReference[];
  nationalSports: ElasticVideoNationalSportReference[];
  schools: ElasticVideoSchoolReference[];
  sectionDivisions: ElasticVideoSectionDivisionReference[];
  sections: ElasticVideoSectionReference[];
  stateDivisions: ElasticVideoStateDivisionReference[];
  states: ElasticVideoStateReference[];
  stateSports: ElasticVideoStateSportReference[];
  teams: ElasticVideoTeamReference[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoAthleteReference {
  athleteId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoCareerReference {
  careerId: string;
  firstName: string;
  lastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoLeagueReference {
  leagueId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoSectionReference {
  sectionId: string;
  allSeasonId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoNationalSportReference {
  allSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoSchoolReference {
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoSectionDivisionReference {
  divisionId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoStateDivisionReference {
  divisionId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoStateReference {
  stateCode: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoStateSportReference {
  stateCode: string;
  allSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoTeamReference {
  allSeasonId: string;
  ssid: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoSchoolHolder {
  id: string;
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoContestReference {
  contestId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoStreamReference {
  streamId: string;
  inProduction: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoThumbnail {
  url: string;
  width?: number;
  height?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoRendition {
  streamingUrl: string;
  pid: string;
  assetType: string;
  deviceType: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\ElasticVideoReferences.cs
export interface ElasticVideoCategory {
  name: string;
  id: string;
  active: boolean;
  categoryType: VideoCategoryType;
  displayName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlAthleteHighlightReference.cs
export interface HudlAthleteHighlightReference {
  hudlAthleteHighlightReferenceId: string;
  highlightId: string;
  hudlAthleteReferenceId: string;
  hudlParticipantIds: string[];
  highlightDuration: number;
  highlightName: string;
  highlightThumbnailUrl: string;
  highlightType: string;
  highlightUrl: string;
  highlightCreatedOn: string;
  createdOn: string;
  modifiedOn: string;
  isDeleted: boolean;
  deletedOn?: string;
  isDeletedInMpx: boolean;
  isTransmitted: boolean;
  transmittedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlAthleteHighlightRendition.cs
export interface HudlAthleteHighlightRendition {
  hudlAthleteHighlightRenditionId: string;
  hudlAthleteHighlightReferenceId: string;
  renditionName: string;
  renditionUrl: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlAthleteReference.cs
export interface HudlAthleteReference {
  hudlAthleteReferenceId: string;
  hudlAthleteId: string;
  careerId: string;
  createdOn: string;
  modifiedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlGamePlayerStatsReference.cs
export interface HudlGamePlayerStatsReference {
  hudlGamePlayerStatsReferenceId: string;
  teamId: string;
  sportSeasonId: string;
  athleteId: string;
  contestId: string;
  hudlTeamReferenceId: string;
  hudlGameReferenceId: string;
  hudlParticipantReferenceId: string;
  isPlayed?: boolean;
  isStarted?: boolean;
  s1?: number;
  s2?: number;
  s3?: number;
  s4?: number;
  s5?: number;
  s6?: number;
  s7?: number;
  s8?: number;
  s9?: number;
  s10?: number;
  s11?: number;
  s12?: number;
  s13?: number;
  s14?: number;
  s15?: number;
  s16?: number;
  s17?: number;
  s18?: number;
  s19?: number;
  s20?: number;
  s21?: number;
  s22?: number;
  s23?: number;
  s24?: number;
  s25?: number;
  s26?: number;
  s27?: number;
  s28?: number;
  s29?: number;
  s30?: number;
  s31?: number;
  s32?: number;
  s33?: number;
  s34?: number;
  s35?: number;
  s36?: number;
  s37?: number;
  s38?: number;
  s39?: number;
  s40?: number;
  s41?: number;
  s42?: number;
  s43?: number;
  s44?: number;
  s45?: number;
  s46?: number;
  s47?: number;
  s48?: number;
  s49?: number;
  s50?: number;
  s51?: number;
  s52?: number;
  s53?: number;
  s54?: number;
  s55?: number;
  s56?: number;
  s57?: number;
  s58?: number;
  s59?: number;
  s60?: number;
  s61?: number;
  s62?: number;
  s63?: number;
  s64?: number;
  s65?: number;
  s66?: number;
  s67?: number;
  s68?: number;
  s69?: number;
  s70?: number;
  s71?: number;
  s72?: number;
  s73?: number;
  s74?: number;
  s75?: number;
  s76?: number;
  s77?: number;
  s78?: number;
  s79?: number;
  s80?: number;
  s81?: number;
  s82?: number;
  s83?: number;
  s84?: number;
  s85?: number;
  s86?: number;
  s87?: number;
  s88?: number;
  s89?: number;
  s90?: number;
  s91?: number;
  s92?: number;
  s93?: number;
  s94?: number;
  s95?: number;
  s96?: number;
  s97?: number;
  s98?: number;
  s99?: number;
  s100?: number;
  s101?: number;
  s102?: number;
  s103?: number;
  s104?: number;
  s105?: number;
  s106?: number;
  s107?: number;
  s108?: number;
  s109?: number;
  s110?: number;
  s111?: number;
  s112?: number;
  s113?: number;
  s114?: number;
  s115?: number;
  s116?: number;
  s117?: number;
  s118?: number;
  s119?: number;
  s120?: number;
  createdOn?: string;
  modifiedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlGameReference.cs
export interface HudlGameReference {
  hudlGameReferenceId: string;
  hudlGameId: string;
  schoolId: string;
  sportSeasonId?: string;
  contestId?: string;
  hudlTeamReferenceId: string;
  hudlSeasonYear: string;
  hudlOpponentTeamId: string;
  isHome?: boolean;
  hudlGameDate?: string;
  hudlGameType: string;
  hudlGameLocation: string;
  createdOn: string;
  modifiedOn: string;
  hudlTeamId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlGameResultReference.cs
export interface HudlGameResultReference {
  hudlGameResultReferenceId: string;
  hudlGameReferenceId: string;
  hudlTeamReferenceId: string;
  teamFirstDowns?: number;
  teamPenaltyCount?: number;
  teamPenaltyYards?: number;
  teamTotalPlays?: number;
  teamScoreFinal?: number;
  teamScoreQ1?: number;
  teamScoreQ2?: number;
  teamScoreQ3?: number;
  teamScoreQ4?: number;
  teamScoreOt1?: number;
  teamScoreOt2?: number;
  teamScoreOt3?: number;
  teamScoreOt4?: number;
  teamScoreOt5?: number;
  teamScoreOt6?: number;
  teamScoreOt7?: number;
  teamScoreOt8?: number;
  teamScoreOt9?: number;
  teamScoreOt10?: number;
  opponentFirstDowns?: number;
  opponentPenaltyCount?: number;
  opponentPenaltyYards?: number;
  opponentTotalPlays?: number;
  opponentScoreFinal?: number;
  opponentScoreQ1?: number;
  opponentScoreQ2?: number;
  opponentScoreQ3?: number;
  opponentScoreQ4?: number;
  opponentScoreOt1?: number;
  opponentScoreOt2?: number;
  opponentScoreOt3?: number;
  opponentScoreOt4?: number;
  opponentScoreOt5?: number;
  opponentScoreOt6?: number;
  opponentScoreOt7?: number;
  opponentScoreOt8?: number;
  opponentScoreOt9?: number;
  opponentScoreOt10?: number;
  teamStatData: number[];
  statsNeedProcessing: boolean;
  createdOn: string;
  modifiedOn: string;
  statsProcessedOn?: string;
  isHudlAutoImport: boolean;
  isMaxPrepsAutoImport: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlHighlightAthleteReference.cs
export interface HudlHighlightAthleteReference {
  hudlHighlightAthleteReferenceId: string;
  hudlHighlightReferenceId: string;
  hudlAthleteId: string;
  hudlAthleteReferenceId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlHighlightReference.cs
export interface HudlHighlightReference {
  hudlHighlightReferenceId: string;
  highlightId: string;
  highlightDuration: number;
  highlightName: string;
  highlightThumbnailUrl: string;
  highlightType: string;
  highlightUrl: string;
  highlightCreatedOn: string;
  createdOn: string;
  modifiedOn: string;
  isDeleted: boolean;
  deletedOn?: string;
  isDeletedInMpx: boolean;
  isTransmitted: boolean;
  transmittedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlHighlightRendition.cs
export interface HudlHighlightRendition {
  hudlHighlightRenditionId: string;
  hudlHighlightReferenceId: string;
  renditionName: string;
  renditionUrl: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlHighlightStateReference.cs
export interface HudlHighlightStateReference {
  hudlHighlightStateReferenceId: string;
  hudlHighlightReferenceId: string;
  state: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlHighlightTeamReference.cs
export interface HudlHighlightTeamReference {
  hudlHighlightTeamReferenceId: string;
  hudlHighlightReferenceId: string;
  hudlTeamId: string;
  hudlTeamReferenceId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlIdInfo.cs
export interface HudlIdInfo {
  referenceId: string;
  hudlType: HudlType;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlIdInfo.cs
export enum HudlType {
  Athlete = 0,
  Participant = 1,
  Team = 2,
  Unknown = 3,
  Compilation = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlParticipantCount.cs
export interface HudlParticipantCount {
  athleteId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlParticipantHighlightCount.cs
export interface HudlParticipantHighlightCount {
  athleteId: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlParticipantHighlightReference.cs
export interface HudlParticipantHighlightReference {
  hudlParticipantHighlightReferenceId: string;
  highlightId: string;
  hudlParticipantReferenceId: string;
  hudlSeasonYear: string;
  highlightDuration: number;
  highlightName: string;
  highlightThumbnailUrl: string;
  highlightType: string;
  highlightUrl: string;
  highlightCreatedOn: string;
  hudlGameId: string;
  hudlGameReferenceId?: string;
  hudlGameDate?: string;
  createdOn: string;
  modifiedOn: string;
  isDeleted: boolean;
  deletedOn?: string;
  isDeletedInMpx: boolean;
  isTransmitted: boolean;
  transmittedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlParticipantHighlightRendition.cs
export interface HudlParticipantHighlightRendition {
  hudlParticipantHighlightRenditionId: string;
  hudlParticipantHighlightReferenceId: string;
  renditionName: string;
  renditionUrl: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlParticipantReference.cs
export interface HudlParticipantReference {
  hudlParticipantReferenceId: string;
  hudlParticipantId: string;
  athleteId: string;
  hudlTeamReferenceId: string;
  hudlSeasonYear: string;
  hudlAthleteReferenceId: string;
  firstName: string;
  lastName: string;
  jerseyNumber: string;
  positions: string[];
  profileImages: Record<string, string>;
  gradYear?: number;
  classYear: string;
  height?: number;
  weight?: number;
  sportSeasonId: string;
  createdOn: string;
  modifiedOn: string;
  isDisabled: boolean;
  isDeleted: boolean;
  hudlTeamId: string;
  hudlAthleteId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlSchoolSummary.cs
export interface HudlSchoolSummary {
  schoolId: string;
  areHighlightsPrivate: boolean;
  hudlTeamId: string;
  isEnabled: boolean;
  modifiedOn: string;
  hudlTeamReferenceId: string;
  gender: string;
  sport: string;
  teamLevel: string;
  allSeasonId: string;
  athleteHighlightCount: number;
  gameHighlightCount: number;
  participantHighlightCount: number;
  teamHighlightCount: number;
  sportSeasonData: HudlSportSeasonSummary[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlSchoolSummary.cs
export interface HudlSportSeasonSummary {
  sportSeasonId: string;
  seasonName: string;
  year: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlTeamHighlightReference.cs
export interface HudlTeamHighlightReference {
  hudlTeamHighlightReferenceId: string;
  highlightId: string;
  hudlTeamReferenceId: string;
  hudlSeasonYear: string;
  highlightDuration: number;
  highlightName: string;
  highlightThumbnailUrl: string;
  highlightType: string;
  highlightUrl: string;
  highlightCreatedOn: string;
  hudlGameId: string;
  hudlGameReferenceId?: string;
  hudlGameDate?: string;
  createdOn: string;
  modifiedOn: string;
  isDeleted: boolean;
  deletedOn?: string;
  isDeletedInMpx: boolean;
  isTransmitted: boolean;
  transmittedOn?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlTeamHighlightRendition.cs
export interface HudlTeamHighlightRendition {
  hudlTeamHighlightRenditionId: string;
  hudlTeamHighlightReferenceId: string;
  renditionName: string;
  renditionUrl: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\HudlTeamReference.cs
export interface HudlTeamReference {
  hudlTeamReferenceId: string;
  hudlTeamId: string;
  teamId: string;
  allSeasonId: string;
  hudlSchoolId: string;
  hudlSchoolName: string;
  hudlGender: string;
  hudlSport: string;
  hudlTeamLevel: string;
  hudlTeamMascot: string;
  hudlTeamLogo: string;
  areHighlightsPrivate: boolean;
  isEnabled: boolean;
  createdOn: string;
  modifiedOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\NFHSVideo.cs
export interface NFHSVideo {
  nfhsVideoId: number;
  eventId: string;
  teamId1?: string;
  teamId2?: string;
  date?: string;
  isTimeTba: boolean;
  streamUrl: string;
  gender: string;
  sport: string;
  teamLevel: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\TeamVideoCount.cs
export interface TeamVideoCount {
  sportSeasonId: string;
  year: string;
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\Video.cs
export interface Video {
  videoId: string;
  userId?: string;
  itemType: string;
  viewedOn: string;
  sourceCategoryId: string;
  duration: number;
  formattedDuration: string;
  createdOn?: string;
  lastModifiedOn: string;
  publishedOn?: string;
  formattedPublishedOn: string;
  isInternalVideo: boolean;
  isInProduction: boolean;
  inBackgroundTransfer: boolean;
  isReviewed: boolean;
  viewCount?: number;
  title: string;
  description: string;
  keywords: string;
  mpxId: string;
  canId: string;
  externalVideoUrl: string;
  externalPartner: string;
  externalPartnerVideoId: string;
  thumbnailUrl: string;
  thumbnailWidth?: number;
  thumbnailHeight?: number;
  canonicalUrl: string;
  thumbnails: VideoThumbnail[];
  renditions: VideoRendition[];
  thumbnail: VideoThumbnail;
  sourceImage: VideoThumbnail;
  categories: VideoCategory[];
  athleteReferences: VideoAthleteReference[];
  careerReferences: VideoCareerReference[];
  contestReferences: VideoContestReference[];
  leagueReferences: VideoLeagueReference[];
  nationalSportReferences: VideoNationalSportReference[];
  schoolReferences: VideoSchoolReference[];
  sectionDivisionReferences: VideoSectionDivisionReference[];
  sectionReferences: VideoSectionReference[];
  stateDivisionReferences: VideoStateDivisionReference[];
  stateReferences: VideoStateReference[];
  stateSportReferences: VideoStateSportReference[];
  teamReferences: VideoTeamReference[];
  contestId?: string;
  contestIdReferences: string[];
  careerIdReferences: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoAthleteReference {
  athleteId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoCareerReference {
  careerId: string;
  firstName: string;
  lastName: string;
  videoCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoLeagueReference {
  leagueId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoSectionReference {
  sectionId: string;
  allSeasonId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoNationalSportReference {
  allSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoSchoolReference {
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoSectionDivisionReference {
  divisionId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoStateDivisionReference {
  divisionId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoStateReference {
  stateCode: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoStateSportReference {
  stateCode: string;
  allSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoTeamReference {
  teamId: string;
  allSeasonId: string;
  sportSeasonId: string;
  schoolId: string;
  name: string;
  state: string;
  city: string;
  mascot: string;
  videoCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoSchoolHolder {
  videoSchoolHolderId: string;
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoContestReference {
  contestId: string;
  sportSeasonId: string;
  schoolDictionary: VideoSchoolHolder[];
  date?: string;
  videoCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoStreamReference {
  streamId: string;
  inProduction: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoRendition {
  videoId: string;
  streamingUrl: string;
  pid: string;
  assetType: string;
  deviceType: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoThumbnail {
  thumbnailId: string;
  videoId: string;
  url: string;
  width?: number;
  height?: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Models\VideoReferenceModels.cs
export interface VideoCategory {
  name: string;
  categoryId: string;
  isActive: boolean;
  categoryType: VideoCategoryType;
  displayName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\AthletePhotogalleryImage.cs
export interface AthletePhotogalleryImage extends PhotogalleryImage {
  athleteId: string;
  sportSeasonId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\ImageMutation.cs
export interface ImageMutation {
  maxWidth: number;
  maxHeight: number;
  sourceBucket: string;
  sourceKey: string;
  destinationBucket: string;
  destinationKey: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\Photogallery.cs
export interface Photogallery {
  photogalleryId: string;
  personId: string;
  photographerFirstName: string;
  photographerLastName: string;
  sportSeasonId: string;
  name: string;
  description: string;
  sponsor: string;
  isDeleted: boolean;
  isPublished: boolean;
  hasImages: boolean;
  isCleared: boolean;
  isApproved: boolean;
  modifiedOn: string;
  optionGroupId: string;
  thumbnailId?: string;
  thumbnailUrl: string;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\PhotogalleryImage.cs
export interface PhotogalleryImage {
  photogalleryImageId: string;
  photogalleryId: string;
  height: number;
  width: number;
  caption: string;
  isDeleted: boolean;
  displayIndex: number;
  isPublished: boolean;
  isNominated: boolean;
  isThumbnail: boolean;
  jerseyNumbers: string;
  sourcePath: string;
  originalSize: number;
  thumbnailSize: number;
  createdOn: string;
  canonicalUrl: string;
  sourceCanonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\PhotogalleryImageRosterRef.cs
export interface PhotogalleryImageRosterRef {
  photogalleryImageRefId: string;
  sportSeasonId: string;
  athleteId: string;
  photogalleryImageId: string;
  updatedBy: string;
  isPublished: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\SportPhotogallery.cs
export interface SportPhotogallery extends Photogallery {
  count: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\UserSubmittedCareerProfileImage.cs
export interface UserSubmittedCareerProfileImage extends UserSubmittedImage {
  careerProfileId?: string;
  athleteId?: string;
  ssid?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\UserSubmittedImage.cs
export interface UserSubmittedImage {
  id: string;
  type: ImageType;
  imageFormat: string;
  status: ImageStatus;
  submittedDate: string;
  userId: string;
  personId: string;
  schoolId: string;
  processedDate?: string;
  processedBy?: string;
  ssid?: string;
  athleteId?: string;
  careerProfileId?: string;
  bucket: string;
  key: string;
  name: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Models\UserSubmittedImageCounts.cs
export interface UserSubmittedImageCounts {
  careerApproved: number;
  careerRejected: number;
  careerSubmitted: number;
  mascotApproved: number;
  mascotRejected: number;
  mascotSubmitted: number;
  rosterApproved: number;
  rosterRejected: number;
  rosterSubmitted: number;
  teamApproved: number;
  teamRejected: number;
  teamSubmitted: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\BaseServiceClient\CachePurgeType.cs
export enum CachePurgeType {
  None = 0,
  Create = 1,
  Update = 2,
  Remove = 3,
  Restore = 4,
  Destroy = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Articles\Enums\ArticleStatus.cs
export enum ArticleStatus {
  Declined = 0,
  Deleted = 1,
  NotSubmitted = 2,
  Published = 3,
  Submitted = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Careers\Enums\AthleteClaimIneligibilityType.cs
export enum AthleteClaimIneligibilityType {
  None = 0,
  UserAlreadyBoundToCareer = 1,
  UserAlreadyBoundToAnotherCareer = 2,
  CareerAlreadyBoundToAnotherUser = 3,
  IneligibleUserMemberType = 4,
  NonMatchingLastName = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Careers\Enums\ParentClaimIneligibilityType.cs
export enum ParentClaimIneligibilityType {
  None = 0,
  UserAlreadyBoundToCareer = 1,
  UserMaxParentClaimsReached = 2,
  IneligibleUserMemberType = 3,
  CareerMaxParentClaimsReached = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contacts\Enums\PersonPosition.cs
export enum PersonPosition {
  ActivitiesDirector = 0,
  Secretary = 1,
  AthleticDirector = 2,
  Trainer = 3,
  SchoolVolunteer = 4,
  Athlete = 5,
  DistrictAthleticDirector = 6,
  AssistantAthleticDirector = 7,
  OTR = 8,
  AssistantCoach = 9,
  HeadCoach = 10,
  BoosterStaff = 11,
  SchoolAdministrator = 12,
  TeamVolunteer = 13,
  Statistician = 14,
  Parent = 15,
  TeamCommunity = 16
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\ContestContextType.cs
export enum ContestContextType {
  Unknown = 0,
  National = 1,
  State = 2,
  Section = 3,
  StateDivision = 4,
  SectionDivision = 5,
  Association = 6,
  League = 7,
  DMA = 8
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\ContestResult.cs
export enum ContestResult {
  Unknown = 0,
  NoResult = 1,
  Win = 2,
  Loss = 3,
  Tie = 4,
  WinByForfeit = 5,
  LossByForfeit = 6,
  DoubleForfeit = 7,
  Placed = 8,
  DidNotPlace = 9,
  DidNotPlaceByForfeit = 10,
  NoPlaceData = 11
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\ContestState.cs
export enum ContestState {
  Unknown = 0,
  Deleted = 1,
  Pregame = 2,
  ContestInProgress = 3,
  Boxscore = 4,
  ScoreNotReported = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\ContestTypes.cs
export enum ContestTypes {
  Conference = 0,
  NonConference = 1,
  Tournament = 2,
  Exhibition = 3,
  Playoff = 4,
  ConferenceTournament = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\DateCodes.cs
export enum DateCodes {
  Default = 0,
  DateTBA = 1,
  TimeTBA = 2,
  DateTimeTBA = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\DayOfWeek.cs
export enum DayOfWeek {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\HomeAwayTypes.cs
export enum HomeAwayTypes {
  Home = 0,
  Away = 1,
  Neutral = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\LiveGameChange.cs
export enum LiveGameChange {
  Date = 0,
  Time = 1,
  Schools = 2,
  Created = 3,
  Deleted = 4,
  Restored = 5,
  None = 6
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\ScorerRequestStatus.cs
export enum ScorerRequestStatus {
  Submitted = 0,
  GameAssigned = 1,
  Waitlist = 2,
  DroppedOut = 3,
  BootedOutByFan = 4,
  BlockedList = 5,
  GamePostponed = 6,
  GameDeleted = 7,
  TeamChangedToTBA = 8,
  CanceledWaitList = 9,
  AutoBootedOut = 10,
  BootedOutByAdmin = 11,
  AutoBootedOutAfterSignupGracePeriod = 12,
  AutoBootedOutAfter1HourInactivity = 13,
  AutoBootedOutAfterInactivityPastAverageContestLength = 14,
  CanceledAssignment = 15,
  TakenOverByFan = 16,
  AlreadyScorerForOpponent = 17,
  TimeTooClose = 18,
  TakenOverByOTR = 19,
  OTRRemovedFromSystem = 20,
  Declined = 99
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Contests\Enums\TournamentRoundType.cs
export enum TournamentRoundType {
  PlayIn = 0,
  Winners = 1,
  PresetLosers = 2,
  StandardLosers = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Enums\LeaderboardContextType.cs
export enum LeaderboardContextType {
  National = 0,
  State = 1,
  Section = 2,
  Division = 3,
  League = 4,
  Association = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Stats\Enums\StatLeaderContext.cs
export enum StatLeaderContext {
  Unknown = 0,
  National = 1,
  State = 2,
  Section = 3,
  Association = 4,
  StateDivision = 5,
  SectionDivision = 6,
  League = 7,
  Team = 8,
  Tournament = 9
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Triggers\Enums\TriggersEnums.cs
export enum TriggerStatus {
  Created = 0,
  Processing = 1,
  Errored = 2,
  Completed = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\CareerRolePermissionType.cs
export enum CareerRolePermissionType {
  Undefined = 0,
  Parent = 1,
  Athlete = 2,
  Follower = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\FavoriteSource.cs
export enum FavoriteSource {
  Unknown = 0,
  MaxprepsApp_IOS = 1,
  MaxprepsApp_Android = 2,
  MaxprepsApp_Unknown = 3,
  TeamsApp_IOS = 4,
  TeamsApp_Android = 5,
  TeamsApp_Unknown = 6,
  Mobile_SiteHeader = 7,
  Desktop_SiteHeader = 8,
  Mobile_TeamHeader = 9,
  Desktop_TeamWall = 10,
  Mobile_MemberProfile = 11,
  Desktop_MemberProfile = 12,
  Mobile_ClaimCareer = 13,
  Desktop_ClaimCareer = 14,
  Mobile_FollowCareer = 15,
  Desktop_FollowCareer = 16,
  Mobile_Community = 17,
  Desktop_Community = 18,
  Mobile_CoachAdminAccess = 19,
  Desktop_CoachAdminAccess = 20,
  Site_Admin = 21,
  Marketing_Email = 22
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\Gender.cs
export enum Gender {
  Unknown = 0,
  Male = 1,
  Female = 2,
  Other = 3,
  PreferNotToSay = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\SubscriptionRoleCode.cs
export enum SubscriptionRoleCode {
  All = 0,
  User = 1,
  CoachAD = 2,
  CoachADState = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\SubscriptionRuleType.cs
export enum SubscriptionRuleType {
  Unknown = 0,
  UserType = 1,
  Permission = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\UserFavoriteTeamNotificationEnabledType.cs
export enum UserFavoriteTeamNotificationEnabledType {
  UNKNOWN = 0,
  APP = 1,
  EMAIL = 2,
  SMS = 3,
  WEB = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\UserFavoriteTeamNotificationSettingType.cs
export enum UserFavoriteTeamNotificationSettingType {
  UNKNOWN = 0,
  GAME_SCORER_STATUS = 1,
  FINAL_SCORE = 2,
  GAME_DELAYED = 3,
  GAME_START = 4,
  LIVE_SCORER_INFO = 5,
  QTR_SCORES_OVERTIME = 6,
  POSSESSION_UPDATE = 7,
  RANKINGS = 8,
  RED_ZONE = 9,
  SCORE_CHANGE = 10,
  TEAM_MEDIA = 11,
  TEAM_STATS = 12,
  UPCOMING_GAME = 13
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Users\Enums\UserValidationLevel.cs
export enum UserValidationLevel {
  MEMBER = 0,
  CONTACT = 1,
  MINIMUM = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SiteSwitches\Enums\SiteSwitchEnums.cs
export enum SiteSwitchEnums {
  AWSForOldSportSeasonLeadersEnabled = 0,
  HomePageStreamingEnabled = 1,
  HomePageEditorialFeatureAutomatic = 2,
  HomePageEditorialFeatureManual = 3,
  HomePageStreamingManual = 4,
  HomePageStreamingAutomaticFridayLive = 5,
  HomePageStreamingAutomaticCourtReportLive = 6,
  HomePageVideoPlayerAutoStart = 7,
  MemberPromoPopup = 8,
  MobileTeamWallARNGAutomaticAdsByDate = 9,
  MobileTeamWallARNGManualAdsOverride = 10,
  FootballSigningDayLiveStream = 11,
  FootballMobileSigningDayLiveStream = 12,
  SitePerf_ScoresTickerEnabled = 13,
  SitePerf_AllowTeamHeaderPhotos = 14,
  SitePerf_AllowContestMatchupTab = 15,
  SitePerf_AllowVideoKeywordSearch = 16,
  AllowCoachAdminHudlStatImport = 17,
  EnableCoachAdminHomePopup = 18,
  DisableAds = 19,
  DisableAdWords = 20,
  DisabledContentPartner = 21,
  ApparelPartnerAdsEnabled = 22,
  MobileHolidayClassicHomePage = 23,
  MobileMLKClassicHomePage = 24,
  AppNowWall = 25,
  TrimmedMobileTeamWall = 26,
  AppScoreBoard = 27,
  AppScoreBoardShare = 28,
  AppScoreBoardPromo = 29,
  GoogleAppPromo = 30,
  ProPhotogalleryImageUpload = 31,
  ProPhotogalleryEXIF = 32,
  DisableExternalPartnerLoads = 33,
  DisableHoverCards = 34,
  OptimizelyEnabled = 35,
  ARNGOptInEnabled = 36,
  ARNGEnabled = 37,
  EnableElasticCache = 38,
  EnableTeamPageCoachAcquisition = 39,
  EnableContestPageLeagueScoreboard = 40,
  EnableMarinesVotingButton = 41,
  FootballNSDPromoUnits = 42,
  AppNewsTabFilmStrip = 43,
  DisablePBPSignup = 44,
  DisableElasticSearchForContextInfo = 45,
  EnableResourceHints = 46,
  HideMobilePageGallery = 47,
  HideMobilePageCareer = 48,
  HideMobilePageSchool = 49,
  HideMobilePageStatLeaders = 50,
  HideMobilePageRankings = 51,
  CachingFileSystemRules = 52,
  CachingKeyValueRules = 53,
  BypassAVCANominationDates = 54,
  BypassStateNominationDates = 55,
  StateNominationData = 56,
  EnableAWSAppNowDataPush = 57,
  LiveGameSingupDefault = 58,
  DisableBriteVerify = 59,
  AssociationData = 60,
  EnableMaintenanceMode = 61,
  EnableTeamStatsMembershipWall = 62,
  EnableTournamentMembershipWall = 63,
  EnabledAutoAcceptAccessCodes = 64,
  GDPREmailComplainancyEnabled = 65,
  DisableAdsByTemplate = 66,
  EnableClaimMyProfile = 67,
  EnableForcedSSLUpgradeOnBaseHandler = 68,
  EnableContentSecurityPolicy = 69,
  MarketingLightboxSolution = 70,
  EnableCollectAdData = 71,
  BidBarrelData = 72,
  FavTeamNotificationViewSetting = 73,
  EnableAOMAds = 74,
  EnableFanTagHighlights = 75,
  EnableResponsiveTeamHeader = 76,
  ProductCategoryTransactionFee = 77,
  EnableContextCache = 78,
  EnableInstartLogic = 79,
  EnableVideoUploadFanChat = 80,
  EnableVideoUploadLiveScoring = 81,
  TACSettings = 82,
  EnableMemberContentBlock = 83,
  EnableFooterTopTeams = 84,
  WriterData = 85,
  BetaFeatures = 86,
  MediaRestrictions = 87,
  RewriterRuleBook = 88,
  EnableCyberSourceTransactionLogging = 89
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Utilities\SlideShows\Enums\PromoType.cs
export enum PromoType {
  National = 0,
  NationalSport = 1,
  State = 2,
  StateSport = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Enums\VideoCategoryType.cs
export enum VideoCategoryType {
  None = 0,
  BoysBaseball = 1,
  BoysBasketball = 2,
  BoysFootball = 3,
  BoysLacrosse = 4,
  BoysSoccer = 5,
  BoysTrackAndField = 6,
  OtherSports = 7,
  OtherSportsFall = 8,
  OtherSportsWinter = 9,
  OtherSportsSpring = 10,
  OtherSportsSummer = 11,
  GirlsBasketball = 12,
  GirlsLacrosse = 13,
  GirlsSoccer = 14,
  GirlsSoftball = 15,
  GirlsTrackAndField = 16,
  GirlsVolleyball = 17,
  ProducedShowBeyondTheX = 18,
  ProducedShowCourtReport = 19,
  ProducedShowFriday5 = 20,
  ProducedShowFridayNightLive = 21,
  ProducedShowMaxPrepsMinute = 22,
  ProducedShowNextStep = 23,
  ProducedShowRevItUp = 24,
  ProducedShowSituationX = 25,
  ProducedShowVarsityCenter = 26,
  ProducedShowWayBackWhen = 27,
  ProducedShowWayBackWhenNfl = 28,
  ProducedShowWayBackWhenNba = 29,
  ProducedShowWayBackWhenCollege = 30,
  ProducedShowWayBackWhenOther = 31,
  ProducedShowWeekendDrill = 32,
  ProducedShowFinalStretch = 33,
  ProducedShowHighSchoolFantasyShow = 34,
  ProducedClipTopPlays = 35,
  ProducedClipRankings = 36,
  ProducedClipWeekendsWildest = 37,
  ProducedClipStatStars = 38,
  ProducedClipGameOfTheWeek = 39,
  ProducedClipCollege = 40,
  ProducedClipPlayoffs = 41,
  ProducedClipPlaysOfTheWeek = 42,
  ProducedClipTrickPlays = 43,
  ProducedClipTopRecruits = 44,
  ProducedClipMaxPrepsTopPlays = 45,
  ProducedClipRankingsBoysBaseball = 46,
  ProducedClipRankingsBoysBasketball = 47,
  ProducedClipRankingsBoysFootball = 48,
  ProducedClipRankingsGirlsBasketball = 49,
  ProducedClipRankingsGirlsSoftball = 50,
  ProducedClipRankingsGirlsVolleyball = 51,
  FeaturedListHomePage = 52,
  FeaturedListVideoCenter = 53,
  FeaturedListBoysFootballSigningDay = 54,
  FeaturedListBoysFootballSigningDayCollegeHighlight = 55,
  FeaturedListFeaturedVideo = 56,
  FeaturedListRecommended = 57,
  GroupingSigningDay = 58,
  FeaturedListReactVideoCenter = 59,
  GroupingZackPoff = 60,
  GroupingZackPoffEpisodes = 61,
  GroupingPlayLikeAGirl = 62,
  GroupingPlayLikeAGirlPodcast = 63,
  GroupingPlayLikeAGirlShortPlays = 64,
  GroupingPlayLikeAGirlAthletes = 65,
  ProducedClipTopPlaysFootball = 66,
  ProducedClipTopPlaysBasketball = 67,
  ProducedClipTopPlaysFall = 68,
  ProducedClipTopPlaysWinter = 69,
  ProducedClipTopPlaysSpring = 70,
  ProducedClipTopPlaysSummer = 71,
  ProducedClipRankingsGirlsSoccer = 72,
  ProducedClipRankingsBoysSoccer = 73,
  ProducedClipRankingsNationalFootball = 74,
  ProducedClipRankingsTexasFootball = 75,
  ProducedClipRankingsCaliforniaFootball = 76,
  GroupingWeNext = 77,
  GroupingWeNextFootball = 78,
  GroupingWeNextBasketball = 79,
  GroupingWeNextOther = 80,
  GroupingJump = 81,
  GroupingJumpFootball = 82,
  GroupingJumpBoysHoops = 83,
  GroupingJumpGirlsHoops = 84,
  GroupingJumpBaseball = 85,
  GroupingJumpSoftball = 86,
  GroupingJumpVolleyball = 87,
  GroupingJumpSoccer = 88,
  GroupingCoachesCorner = 89,
  GroupingCoachesCornerBasketball = 90,
  GroupingCoachesCornerFootball = 91,
  GroupingCoachesCornerThanks = 92,
  GroupingWhyWeLove = 93,
  GroupingPhotoVideo = 94,
  GroupingPhotoVideoSlideshow = 95,
  Hudl = 96,
  FanTag = 97,
  VRV = 98,
  PlayAmazingPlay = 99,
  PlayTouchdown = 100,
  PlayBigHitBlock = 101,
  PlayBuzzerBeater = 102,
  PlayDunk = 103,
  PlayLongShot = 104,
  PlayHomeRun = 105,
  PlayDefensiveHighlight = 106,
  PlayKill = 107,
  PlayLongRally = 108,
  PlayGoal = 109,
  PlaySave = 110
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\Videos\Enums\VideoItemType.cs
export enum VideoItemType {
  All = -1,
  None = 0,
  HUDL_Game_Career = 1,
  HUDL_Game_Athlete = 2,
  HUDL_Game_Team = 3,
  HUDL_Premium_Career = 4,
  HUDL_Premium_Athlete = 5,
  HUDL_Premium_Team = 6,
  HUDL_TopPlay_Team = 7,
  HUDL_TopPlay_Career = 8,
  HUDL_TopPlay_Athlete = 9,
  HUDL_Recap_Athlete = 10,
  HUDL_Recap_Team = 11,
  HUDL_Game_Preview = 12
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Enums\ImageStatus.cs
export enum ImageStatus {
  None = 0,
  Submitted = 1,
  Approved = 2,
  Rejected = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\VisualContent\Enums\ImageType.cs
export enum ImageType {
  None = 0,
  Team = 1,
  Mascot = 2,
  Roster = 3,
  Career = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestBasicSp.cs
export interface ContestBasicSp {
  contest: ContestsCommonOffload[];
  contestTeams: TeamsCommonOffload[];
  contestTournament: TournamentsCommonOffload[];
  contestSchools: SchoolsCommonOffload[];
  contestTeamInfo: TeamInfosCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestBasicWithScorerSp.cs
export interface ContestBasicWithScorerSp {
  contestBasic: ContestBasicSp;
  qwixcoreScorerInfo: QwixcoreScorersCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestCompleteSp.cs
export interface ContestCompleteSp {
  contestBasic: ContestBasicSp;
  qwixcoreGame: QwixcoreGamesCommonOffload[];
  inGame: InGamesCommonOffload[];
  standings: StandingsCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestCompleteWithHudl.cs
export interface ContestCompleteWithHudl extends ContestCompleteSp {
  hudlInfo: HudlInfoCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestSingleSp.cs
export interface ContestSingleSp extends ContestCompleteSp {
  contestId: string;
  stateDivisionInfo: StateDivisionInfoCommonOffload[];
  sectionDivisionInfo: SectionDivisionInfoCommonOffload[];
  rankings: RankingsCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\ContestWithQwixcoreSp.cs
export interface ContestWithQwixcoreSp {
  contestBasic: ContestBasicSp;
  qwixcoreBasic: QwixcoreBasicSp;
  inGame: InGameLiveCommonOffload[];
  standings: StandingsCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\ContestsCommonOffload.cs
export interface ContestsCommonOffload extends UserInfoCommonOffload {
  id: string;
  ssid: string;
  tournamentId?: string;
  date?: string;
  dateCode?: number;
  location: string;
  gow: boolean;
  hasResult: boolean;
  deleted: boolean;
  imported?: string;
  flag: boolean;
  scoreImport: boolean;
  overrideConf: boolean;
  storyPickup?: string;
  scoreStamp?: string;
  buildNewStory: boolean;
  hasStory: boolean;
  scheduleImport: boolean;
  tournamentBracketId?: string;
  scoreSource: string;
  gameSource: string;
  createdStamp?: string;
  modifiedStamp?: string;
  scoreFromMembershipId?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\HudlInfoCommonOffload.cs
export interface HudlInfoCommonOffload {
  contestId?: string;
  schoolId: string;
  hudlGameId: string;
  hudlStatsExist: boolean;
  hudlStatsNeedProcessing: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\InGamesCommonOffload.cs
export interface InGamesCommonOffload {
  contestId: string;
  cnt: number;
  lastUpdate: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\RankingsCommonOffload.cs
export interface RankingsCommonOffload {
  id: string;
  state: string;
  ssid?: string;
  rank?: number;
  schoolId?: string;
  rating: string;
  record: string;
  leagueRecord: string;
  section: string;
  sectionId?: string;
  league: string;
  leagueId?: string;
  movement: string;
  strength: string;
  national?: boolean;
  version?: number;
  stamp?: string;
  teamSize?: number;
  type: string;
  scraper?: boolean;
  stateDivisionId?: string;
  sectionDivisionId?: string;
  notificationStamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\SchoolsCommonOffload.cs
export interface SchoolsCommonOffload {
  schoolId: string;
  name: string;
  city: string;
  state: string;
  zip: string;
  address: string;
  mascot: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  colorName1: string;
  colorName2: string;
  colorName3: string;
  colorName4: string;
  utcOffSet?: number;
  dstOffSet?: number;
  isFootballMascotHelmetAvailable?: boolean;
  longitude?: number;
  latitude?: number;
  rivalSchoolId: string;
  rivalryGameName: string;
  mascotUploadedDate?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\SectionDivisionInfoCommonOffload.cs
export interface SectionDivisionInfoCommonOffload {
  id: string;
  name: string;
  ssid: string;
  sectionId: string;
  sectionName: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\StandingsCommonOffload.cs
export interface StandingsCommonOffload {
  replicationKey: string;
  schoolId: string;
  wins?: number;
  losses?: number;
  ties?: number;
  streak?: number;
  streakResult: string;
  confWins?: number;
  confLosses?: number;
  confTies?: number;
  winningPercentage?: number;
  confWinningPercentage?: number;
  points?: number;
  pointsAgainst?: number;
  awayLosses?: number;
  awayWins?: number;
  awayTies?: number;
  homeWins?: number;
  homeLosses?: number;
  homeTies?: number;
  neutralWins?: number;
  neutralLosses?: number;
  neutralTies?: number;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\StateDivisionInfoCommonOffload.cs
export interface StateDivisionInfoCommonOffload {
  id: string;
  name: string;
  ssid: string;
  stateCode: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\TeamInfosCommonOffload.cs
export interface TeamInfosCommonOffload {
  teamSize?: number;
  coachName: string;
  schoolId: string;
  sectionId: string;
  ssid: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\TeamsCommonOffload.cs
export interface TeamsCommonOffload {
  replicationKey: string;
  ssid: string;
  contestId: string;
  schoolId?: string;
  schoolTba: boolean;
  contestType?: number;
  haType: number;
  index?: number;
  score?: number;
  result: string;
  forfeit: boolean;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  deleted: boolean;
  hasStats: boolean;
  scorePrediction?: number;
  statSupplierId?: string;
  statEntryDate?: string;
  totalsNeedUpdate: boolean;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
  bFieldsLastUpdated?: string;
  finalScoreLastUpdated?: string;
  teamModifiedStamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\TournamentsCommonOffload.cs
export interface TournamentsCommonOffload {
  tournamentId: string;
  name: string;
  city: string;
  state: string;
  startDate?: string;
  endDate?: string;
  splitBrackets: boolean;
  allowReportedScores: boolean;
  tournamentOrganizationId: string;
  isPlayOff: boolean;
  tournamentHasLogo: boolean;
  tournamentClickUrl: string;
  tournamentLogoHeight?: number;
  tournamentLogoWidth?: number;
  tournamentLastUpdated?: string;
  ssid: string;
  tournamentBracketId: string;
  teamCount?: number;
  isBracketPublished?: boolean;
  bracketName: string;
  bracketCity: string;
  bracketHasLogo: boolean;
  bracketClickUrl: string;
  bracketLogoWidth?: number;
  bracketLogoHeight?: number;
  bracketPublishDate?: string;
  lockGameDetails: boolean;
  bracketLastUpdated?: string;
  tournamentBracketRoundId: string;
  isRoundEndDateTba: boolean;
  roundDateTba: boolean;
  roundDateTime: string;
  roundEndDate?: string;
  roundTimeTba: boolean;
  tournamentBracketGamesInMatchup: number;
  tournamentBracketMatchupId: string;
  tournamentBracketMatchupGamesInMatchup: number;
  tournamentBracketGameId: string;
  tournamentBracketGameIndex: number;
  contestId: string;
  tournamentOrganizationName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Common\UserInfoCommonOffload.cs
export interface UserInfoCommonOffload {
  email: string;
  membershipId: string;
  memberFirstName: string;
  memberLastName: string;
  memberCustomName: string;
  memberOrganization: string;
  officialScoreReporter: boolean;
  allowFullNameAttribution: boolean;
  firstTimeScorer: boolean;
  scoringRole: string;
  cellPhone: string;
  cellProvider: string;
  sendTextMessage: boolean;
  isQualityScorer: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreBasicSp.cs
export interface QwixcoreBasicSp {
  qwixcoreGame: QwixcoreGamesCommonOffload[];
  qwixcoreTeams: QwixcoreTeamsCommonOffload[];
  qwixcorePeriods: QwixcorePeriodsCommonOffload[];
  qwixcoreAlerts: QwixcoreGameDatasCommonOffload[];
  qwixcoreScorerInfo: QwixcoreScorersCommonOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreBasicWithPartnerSp.cs
export interface QwixcoreBasicWithPartnerSp extends QwixcoreBasicSp {
  partnerInfo: PartnerInfoOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreCompleteSp.cs
export interface QwixcoreCompleteSp extends QwixcoreWithContestSp {
  inactivityReports: QwixcoreInactivityReportOffload[];
  abuseReports: QwixcoreAbuseReportOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreContestWithInactivitySp.cs
export interface QwixcoreContestWithInactivitySp extends QwixcoreWithContestSp {
  inactivityReports: QwixcoreInactivityReportOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreLogsSp.cs
export interface QwixcoreLogsSp {
  scorerRequestLogs: ScoreRequestLogsOffload[];
  gameStateLogs: GameStateLogsOffload[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\QwixcoreWithContestSp.cs
export interface QwixcoreWithContestSp {
  qwixcoreBasic: QwixcoreBasicSp;
  contestBasic: ContestBasicSp;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\GameStateLogsOffload.cs
export interface GameStateLogsOffload {
  id: number;
  qwixcoreGameId: string;
  gameStarted: boolean;
  gameStartedDate?: string;
  gameCompleted: boolean;
  gameCompletedBySystem: boolean;
  gameCompletedDate?: string;
  gameScorerCheckedIn: boolean;
  gameScorerCheckedInDate?: string;
  gameDelayed: boolean;
  gameDelayedDate?: string;
  gamePostponed: boolean;
  gamePostponedDate?: string;
  commentaryBlocked: boolean;
  commentaryBlockedDate?: string;
  ignoreBfields: boolean;
  membershipId?: string;
  scorerRequestId?: number;
  currentPeriod: string;
  stamp: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\InGameLiveCommonOffload.cs
export interface InGameLiveCommonOffload extends UserInfoCommonOffload {
  id: number;
  contestId: string;
  teamScore?: number;
  teamPeriodData?: number;
  opponentScore?: number;
  opponentPeriodData?: number;
  gamePeriod: string;
  gameTime?: number;
  submittedStamp: string;
  localStamp: string;
  commentary: string;
  hasPhoto: boolean;
  photoHeight?: number;
  photoWidth?: number;
  videoId?: string;
  jobId?: number;
  videoFileName: string;
  videoFileNameSrc: string;
  hasVideo?: boolean;
  videoErrorMessage: string;
  videoTranscoded?: boolean;
  platform: string;
  videoTranscodedStamp?: string;
  videoSubmittedStamp?: string;
  isDeleted?: boolean;
  updateStamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\PartnerInfoOffload.cs
export interface PartnerInfoOffload {
  id: string;
  ssid: string;
  contestId: string;
  partnerGameId: string;
  partnerCode: number;
  createDate: string;
  isNotRanked?: boolean;
  partnerMembershipId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreAbuseReportOffload.cs
export interface QwixcoreAbuseReportOffload {
  id: number;
  qwixcoreGameAlertId: number;
  qwixcoreGameId: string;
  membershipId: string;
  reportedStamp: string;
  memberFirstName: string;
  memberLastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreGameDatasCommonOffload.cs
export interface QwixcoreGameDatasCommonOffload {
  id: number;
  qwixcoreGameId: string;
  alertTypeId: number;
  gamePeriod: string;
  gameTime: string;
  schoolId?: string;
  player1?: number;
  player2?: number;
  player3?: number;
  player1Id?: string;
  player2Id?: string;
  player3Id?: string;
  yardInfo?: number;
  fieldSide?: string;
  currentScore: string;
  scorerCommentary: string;
  localTime: string;
  stamp: string;
  notificationAssetId: string;
  hasPhoto: boolean;
  photoHeight?: number;
  photoWidth?: number;
  scorerRequestId?: number;
  sponsorNote: string;
  sponsorImageUrl: string;
  sponsorClickUrl1: string;
  sponsorTextUrl1: string;
  sponsorClickUrl2: string;
  sponsorTextUrl2: string;
  videoId?: string;
  isDeleted: boolean;
  updateStamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreGamesCommonOffload.cs
export interface QwixcoreGamesCommonOffload {
  id: string;
  contestId: string;
  ssid: string;
  membershipId?: string;
  scorerRequestId?: number;
  gameStarted: boolean;
  gameStartedDate?: string;
  gameCompleted: boolean;
  gameCompletedBySystem: boolean;
  gameCompletedDate?: string;
  gameScorerCheckedIn: boolean;
  gameScorerCheckedInDate?: string;
  gameDelayed: boolean;
  gameDelayedDate?: string;
  gamePostponed: boolean;
  gamePostponedDate?: string;
  commentaryBlocked: boolean;
  commentaryBlockedDate?: string;
  createdStamp: string;
  modifiedStamp: string;
  shortScoringUrl: string;
  shortViewingUrl: string;
  shortCancellationUrl: string;
  shortReportIssueUrl: string;
  viewCount: number;
  allowGameResetByScorer: boolean;
  ignoreBFields: boolean;
  shortEmailScoringUrl: string;
  shortSmsScoringUrl: string;
  shortGlobalPopupScoringUrl: string;
  lastGameUpdateStamp?: string;
  lastScorerChangeStamp?: string;
  schoolId: string;
  isQualityGame: boolean;
  isPrimaryScorer: boolean;
  contestDate?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreInactivityReportOffload.cs
export interface QwixcoreInactivityReportOffload {
  id: number;
  qwixcoreGameId: string;
  membershipId: string;
  reportedStamp: string;
  memberFirstName: string;
  memberLastName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcorePeriodsCommonOffload.cs
export interface QwixcorePeriodsCommonOffload {
  id: number;
  qwixcoreGameId: string;
  identifier: string;
  sort: number;
  inProgress: boolean;
  completed: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreScorersCommonOffload.cs
export interface QwixcoreScorersCommonOffload extends UserInfoCommonOffload {
  currentStatus: number;
  modifiedStamp: string;
  submittedStamp: string;
  id: number;
  qwixcoreGameId: string;
  contestId: string;
  schoolId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\QwixcoreTeamsCommonOffload.cs
export interface QwixcoreTeamsCommonOffload {
  id: number;
  qwixcoreGameId: string;
  schoolId: string;
  ssid: string;
  haType: number;
  b1?: number;
  b2?: number;
  b3?: number;
  b4?: number;
  b5?: number;
  b6?: number;
  b7?: number;
  b8?: number;
  b9?: number;
  b10?: number;
  b11?: number;
  b12?: number;
  b13?: number;
  b14?: number;
  b15?: number;
  b16?: number;
  b17?: number;
  b18?: number;
  b19?: number;
  b20?: number;
  b21?: number;
  b22?: number;
  b23?: number;
  b24?: number;
  b25?: number;
  b26?: number;
  b27?: number;
  b28?: number;
  b29?: number;
  b30?: number;
  final?: number;
  modifiedStamp: string;
  timeOuts?: number;
  name: string;
  city: string;
  state: string;
  mascot: string;
  color1: string;
  mascotUploadedDate?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-apiserviceclients\ApiServiceClients\StoredProcedures\Contests\Qwixcore\Common\ScoreRequestLogsOffload.cs
export interface ScoreRequestLogsOffload {
  id: number;
  scorerRequestId: number;
  requestStatus: number;
  stamp?: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\AuthTokenBase.cs
export interface AuthTokenBase {
  userId: string;
  createdOn: string;
  tokenSource: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\BasicAssociation.cs
export interface BasicAssociation {
  associationId: string;
  name: string;
  includedInReports: boolean;
  imageUrl: string;
  isPublished: boolean;
  belongsToSection: boolean;
  code: string;
  stateCode: string;
  repName: string;
  repEmail: string;
  repPhone: string;
  governingBodyName: string;
  governingBodyUrl: string;
  governingBodyAbbreviation: string;
  governingBodyIsPartner: boolean;
  governingBodyAssociationId: string;
  governingBodyImageUrl: string;
  governingBodyImageWidth: number;
  governingBodyImageHeight: number;
  governingBodyImageAspectRatio: number;
  sectionId?: string;
  tournamentOrganizationId?: string;
  stateId: string;
  stateName: string;
  isStatePrimaryAssociation?: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\Calendar.cs
export interface Calendar {
  prodId: string;
  scale: string;
  name: string;
  description: string;
  timeZone: string;
  publishedTtl: string;
  timeStamp: string;
  method: string;
  version: string;
  id: string;
  events: Event[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\CommonResult.cs
export interface CommonResult<T> {
  status: number;
  message: string;
  cacheResult: string;
  data: T;
  warnings: string[];
  errors: string[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\CompetitiveSeason.cs
export interface CompetitiveSeason {
  name: string;
  season: string;
  year: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\ConcordiaNav.cs
export interface ConcordiaNavLink {
  url: string;
  text: string;
  description: string;
  thumbnailUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\ConcordiaNav.cs
export interface ConcordiaNavSection {
  links: ConcordiaNavLink[];
  header: string;
  id: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\ConcordiaNav.cs
export interface ConcordiaNav {
  allSeasonId: string;
  season: string;
  sections: ConcordiaNavSection[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\Event.cs
export interface Event {
  start: string;
  end: string;
  timeStamp: string;
  created: string;
  lastModified: string;
  uid: string;
  description: string;
  location: string;
  summary: string;
  organizer: string;
  class: string;
  categories: string;
  latitude: number;
  longitude: number;
  geo: string;
  timeZone: any;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\GenderSport.cs
export interface GenderSport {
  key: string;
  genderId: string;
  sportId: string;
  gender: string;
  sport: string;
  defaultSeason: string;
  isNational: boolean;
  isMultiSeasoned: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\MpDynamoDbTableRaw.cs
export interface MpDynamoDbTableRaw {
  tableName: string;
  partitionKeyName: string;
  sortKeyName: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\PagedResults.cs
export interface PagedResults<T> {
  currentPage: number;
  pageCount: number;
  pageSize: number;
  totalCount: number;
  results: T[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\Sport.cs
export interface Sport {
  sportId: string;
  name: string;
  groupName: string;
  code: string;
  shortCode: string;
  value: string;
  defaultGender: string;
  singleGender: boolean;
  statModel: StatModel;
  scheduleModel: ScheduleModel;
  contestName: string;
  athleteName: string;
  participatingVerb: string;
  hasJerseyNumbers: boolean;
  fullCovered: boolean;
  periodAlias: string;
  pointAlias: string;
  overtimeAlias: string;
  overtimeShortAlias: string;
  overtimePeriodCountsIncludeRegulationPeriods: boolean;
  tiebreakerAlias: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\Sport.cs
export enum StatModel {
  Standard = 0,
  Custom = 1,
  None = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\Sport.cs
export enum ScheduleModel {
  Standard = 0,
  Custom = 1,
  Limited = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\SportSeason.cs
export interface SportSeason {
  sportSeasonId: string;
  name: string;
  allSeasonId: string;
  genderId: string;
  gender: string;
  sportId: string;
  sport: string;
  levelId: string;
  teamLevelId: string;
  level: string;
  teamLevel: string;
  seasonId: string;
  season: string;
  year: string;
  isActive: boolean;
  isFullyCovered: boolean;
  isPublished: boolean;
  isNational: boolean;
  formattedNameFanPageDefault: string;
  formattedNameAdminDefault: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\State.cs
export interface State {
  stateId: string;
  name: string;
  nameLong: string;
  abbreviation: string;
  code: string;
  isStandard: boolean;
  hasSections: boolean;
  areaId: string;
  isFullyCovered: boolean;
  isExtended: boolean;
  hasCoverage: boolean;
  leagueAlias: string;
  sectionAlias: string;
  divisionAlias: string;
  governingBodyIsPartner: boolean;
  governingBodyUrl: string;
  governingBodyName: string;
  governingBodyAbbreviation: string;
  governingBodyAssociationId: string;
  governingBodyImageUrl: string;
  governingBodyImageWidth: number;
  governingBodyImageHeight: number;
  governingBodyImageAspectRatio: number;
  coachAssociationId: string;
  coachAssociationName: string;
  coachAssociationAbbreviation: string;
  coachAssociationNominationWindows: NominationWindow[];
  coachAssociationNominationRequirements: NominationRequirements[];
  coachAssociationNeedsConfirmation: boolean;
  coachAssociationCanRankNominations: boolean;
  coachAssociationNominationConfirmationMessage: string;
  coachAssociationNominationMessage: string;
  coachAssociationMaxCommentsLength: number;
  timeZoneCode: string;
  timeZoneName: string;
  timeZoneOffsetText: string;
  timeZoneOffset: number;
  timeZoneObservesDayLightSavings: boolean;
  canonicalUrl: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\StateCoachAssociation.cs
export interface NominationWindow {
  sportSeasonId: string;
  startsOn: string;
  endsOn: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\StateCoachAssociation.cs
export interface StateCoachAssociation {
  coachAssociationId: string;
  name: string;
  abbreviation: string;
  nominationWindows: NominationWindow[];
  nominationRequirements: NominationRequirements[];
  needsConfirmation: boolean;
  canRankNominations: boolean;
  confirmationMessage: string;
  nominationMessage: string;
  timeZone: TimeZone;
  maxCommentsLength: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\StateCoachAssociation.cs
export enum NominationRequirements {
  MustBeSenior = 0,
  MustHaveStats = 1,
  MustHavePlayedTwoThirdOfMatches = 2,
  MustRemoveSTDStats = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\StateGoverningBody.cs
export interface StateGoverningBodyImage {
  url: string;
  width: number;
  height: number;
  aspectRatio: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\StateGoverningBody.cs
export interface StateGoverningBody {
  name: string;
  abbreviation: string;
  url: string;
  associationId: string;
  isPartner: boolean;
  images: StateGoverningBodyImage[];
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Models\TimeZone.cs
export interface TimeZone {
  code: string;
  name: string;
  offsetText: string;
  offset: number;
  observesDayLightSavings: boolean;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\ContestActivitySource.cs
export interface ContestActivitySourceInfo {
  source: ContestSources;
  subSource: ContestSubSources;
  type: ScheduleTypes;
  subType: ScheduleSubTypes;
  userId: string;
  processingUserId: string;
  roleId: string;
  details: string;
  importId: string;
  result: number;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\PageActivitySource.cs
export interface PageActivitySourceInfo {
  source: PageSources;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\RegistrationActivitySource.cs
export interface RegistrationActivitySourceInfo {
  source: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\RosterActivitySource.cs
export interface RosterActivitySourceInfo {
  source: RosterSources;
  subSource: RosterSubSources;
  type: RosterTypes;
  subType: RosterSubTypes;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\ScoreActivitySource.cs
export interface ScoreActivitySourceInfo {
  source: ContestSources;
  subSource: ContestSubSources;
  type: ScoreTypes;
  subType: ScoreSubTypes;
  userId: string;
  processingUserId: string;
  roleId: string;
  activityResult: number;
  resultDetails: string;
  importId: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\Models\UserActivitySource.cs
export interface UserActivitySourceInfo {
  source: string;
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ActivityTypes {
  None = 0,
  Added = 1,
  Removed = 2,
  Updated = 3,
  Restored = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ActivitySourceType {
  None = 0,
  Roster = 1,
  Page = 2,
  Contest = 4,
  Registration = 8,
  User = 16,
  Score = 32
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum PageSources {
  Unknown = 0,
  MaxprepsApp_IOS = 1,
  MaxprepsApp_Android = 2,
  MaxprepsApp_Unknown = 3,
  TeamsApp_IOS = 4,
  TeamsApp_Android = 5,
  TeamsApp_Unknown = 6,
  Mobile_CoachAdmin = 7,
  Desktop_CoachAdmin = 8,
  Mobile_SiteAdmin = 9,
  Desktop_SiteAdmin = 10,
  Mobile_SchoolAdmin = 11,
  Desktop_SchoolAdmin = 12,
  Mobile_AutoAccept = 13,
  Desktop_AutoAccept = 14,
  Mobile_GameChanger = 15,
  Desktop_GameChanger = 16,
  Mobile_Community = 17,
  Desktop_Community = 18,
  Mobile_Career = 19,
  Desktop_Career = 20,
  Volunteer_Request = 21
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum RosterSources {
  None = 0,
  iOS = 1,
  Android = 2,
  SiteAdmin = 3,
  CoachAdmin = 4,
  StateAssnAdmin = 5,
  MeetMgrAdmin = 6,
  RosterImporter = 7,
  GameChanger = 8,
  StateFeed = 9,
  SimulationFeed = 10,
  PublicSite = 11,
  Hudl = 12
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum RosterSubSources {
  None = 0,
  MPCoachApp = 1,
  MaxStatsApp = 2,
  MaxPrepsApp = 3,
  ManualEntry = 4,
  FileImport = 5,
  ThroughFeeds = 6,
  SFVisual = 7,
  SFManual = 8,
  SFAuto = 9,
  Corrections = 10,
  CareerAdmin = 11,
  RecordBook = 12,
  UserSubmission = 13,
  KHSAA = 14,
  TeamsApp = 15
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum RosterTypes {
  None = 0,
  Added = 1,
  Removed = 2,
  Updated = 3,
  Restored = 4
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum RosterSubTypes {
  None = 0
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ContestSources {
  SiteAdmin = 0,
  CoachAdmin = 1,
  AssociationAdmin = 4,
  TournamentAdmin = 5,
  WriterAdmin = 6,
  SchoolAdmin = 7,
  MeetManagerAdmin = 8,
  PhotographyAdmin = 9,
  StatSupplierAdmin = 10,
  ImportSystem = 11,
  ScoreFinder = 12,
  GameChanger = 13,
  MobileApp = 14,
  FanSide = 15,
  Hudl = 16,
  ReportFinalScoreEngine = 17,
  TournamentProcess = 18
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ContestSubSources {
  None = 0,
  ScoreFinderVisual = 1,
  ScoreFinderManual = 2,
  GameChangerAutomatic = 3,
  GameChangerManual = 4,
  MobileAppMPCoachiOS = 5,
  MobileAppMPCoachAndriod = 6,
  MobileAppMaxStatsFBiOS = 7,
  MobileAppMaxStatsBBiOS = 8,
  MobileAppMPFaniOS = 9,
  MobileAppMPFanAndroid = 10,
  TournamentProcessBracketMover = 11,
  MobileAppTeamsAppAndriod = 12,
  MobileAppTeamsAppiOS = 13,
  SiteAdminDeleteContestsImport = 14,
  LiveScoring = 15
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ScheduleTypes {
  ContestAddition = 0,
  ContestUpdate = 1,
  ContestDeletion = 2,
  ContestRestored = 3
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ScheduleSubTypes {
  None = 0,
  TournamentBind = 1,
  TournamentUnbind = 2,
  TeamChanged = 3,
  DateChanged = 4,
  TimeChanged = 5
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ScoreTypes {
  ScoreAddition = 0,
  ScoreUpdate = 1,
  ScoreRemoval = 2
}

// ..\..\..\..\..\..\..\Projects\Git\maxpreps-apiutilities-corecommon\Activity\ActivityEnums.cs
export enum ScoreSubTypes {
  None = 0,
  FinalScore = 1,
  BoxScore = 2,
  TeamBasedStats = 3
}
